import { appActions } from "redux/app/slice/app"
import axios from "axios"
import { call, put, select } from "redux-saga/effects"
import slice from "../slice/user"
import { toast } from "react-toastify"
import { saveAs } from "file-saver"

const baseUrl = process.env.REACT_APP_API_MY_URL

export function* getUserTypeList() {
  try {
    yield put(appActions.setIsLoading(true))
    const { data } = yield call(axios.get, `${baseUrl}/user/role/`)
    if (data.success) {
      yield put(appActions.setUserTypeList(data.data))
    }
  } catch (e) {
    console.log(e)
  }
  yield put(appActions.setIsLoading(false))
}

export function* getFrontlineUsersList(action) {
  try {
    yield put(appActions.setIsLoading(true))
    const {
      page,
      search,
      job_class,
      status,
      restaurant,
      hire_date,
      orderBy,
      user_type,
      raffle_access,
      usersLoginStatus,
      policyAndProcedureAccepted
    } = action.payload

    let params = `page=${page}`
    if (search && search !== "") {
      params += `&search=${search}`
    }
    if (job_class && job_class !== "All") {
      params += `&job_class=${job_class}`
    }
    if (status && status !== "All") {
      params += `&status=${status}`
    }
    if (restaurant && restaurant !== "All") {
      params += `&restaurant=${restaurant}`
    }
    if (hire_date) {
      params += `&hire_date=${hire_date}`
    }
    if (orderBy) {
      params += `&order_by=${orderBy}`
    }
    if (user_type) {
      params += `&user_type=${user_type}`
    }
    if (raffle_access && raffle_access !== "All") {
      params += `&raffle_access=${raffle_access}`
    }
    if (usersLoginStatus) {
      params += `&user_login_status=${usersLoginStatus}`
    }
    if (policyAndProcedureAccepted && policyAndProcedureAccepted !== "All") {
      params += `&policy_accepted=${policyAndProcedureAccepted}`
    }
    const { data } = yield call(axios.get, `${baseUrl}/super-admin/users?${params}`)
    if (data.success) {
      yield put(
        slice.actions.setFrontlineUserList({
          totalPages: data?.data?.pages,
          data: data?.data.results || [],
          policy_and_procedure: data?.data?.policy_and_procedure_document_url || ""
        })
      )
      yield put(slice.actions.setTotalUserCount(data?.data?.count))
      yield put(slice.actions.setTotalActiveUser(data?.data?.active_user_count))
    }
  } catch (e) {
    console.log(e)
  }
  yield put(appActions.setIsLoading(false))
}

export function* exportFrontlineUsers(action) {
  try {
    yield put(appActions.setIsLoading(true))
    const {
      page,
      search,
      job_class,
      status,
      restaurant,
      hire_date,
      orderBy,
      user_type,
      raffle_access,
      usersLoginStatus,
      export: exportFlag
    } = action.payload || {}

    let params = `export=${exportFlag || "TRUE"}`
    if (page) {
      params += `&page=${page}`
    }
    if (search && search !== "") {
      params += `&search=${search}`
    }
    if (job_class && job_class !== "All") {
      params += `&job_class=${job_class}`
    }
    if (status && status !== "All") {
      params += `&status=${status}`
    }
    if (restaurant && restaurant !== "All") {
      params += `&restaurant=${restaurant}`
    }
    if (hire_date) {
      params += `&hire_date=${hire_date}`
    }
    if (orderBy) {
      params += `&order_by=${orderBy}`
    }
    if (user_type) {
      params += `&user_type=${user_type}`
    }
    if (raffle_access && raffle_access !== "All") {
      params += `&raffle_access=${raffle_access}`
    }
    if (usersLoginStatus) {
      params += `&user_login_status=${usersLoginStatus}`
    }

    const { data } = yield call(axios.get, `${baseUrl}/super-admin/users?${params}`)
    if (data.success) {
      const fileUrl =
        data?.data?.file_url || data?.data?.file || data?.data?.export_file || data?.data?.fileUrl

      if (fileUrl) {
        if (fileUrl.includes("base64")) {
          const [metadata, base64Data] = fileUrl.split(";base64,")
          const mimeType = metadata.split(":")[1]?.split(";")[0] || "application/octet-stream"
          const fileName = metadata.split("name=")[1] || "frontline-users.xlsx"
          const binaryData = Uint8Array.from(atob(base64Data), (char) => char.charCodeAt(0))
          const blob = new Blob([binaryData], { type: mimeType })
          saveAs(blob, fileName)
        } else if (typeof document !== "undefined") {
          const link = document.createElement("a")
          link.href = fileUrl
          link.setAttribute("download", "frontline-users.xlsx")
          document.body.appendChild(link)
          link.click()
          document.body.removeChild(link)
        }
      }
    }
  } catch (e) {
    console.log(e)
  }
  yield put(appActions.setIsLoading(false))
}

export function* getFrontlineUsersData() {
  try {
    const id = yield select((store) => store?.superAdmin?.frontlineUser?.id ?? "")
    yield put(appActions.setIsLoading(true))

    const { data } = yield call(axios.get, `${baseUrl}/super-admin/${id}/`)
    if (data.success) {
      yield put(slice.actions.setFrontlineUserData(data?.data || {}))
    }
  } catch (e) {
    console.log(e)
  }
  yield put(appActions.setIsLoading(false))
}

export function* EditFrontlineUsersData(action) {
  try {
    const { payload, onClose } = action.payload
    const id = yield select((store) => store?.superAdmin?.frontlineUser?.id ?? "")
    yield put(appActions.setIsLoading(true))

    const { data } = yield call(axios.patch, `${baseUrl}/super-admin/${id}/`, payload)
    if (data.success) {
      toast.success("Update Successful", {
        position: "bottom-left",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: false,
        draggable: false,
        progress: undefined,
        theme: "dark"
      })
    }
    onClose()
  } catch (e) {
    console.log(e)
  }
  yield put(appActions.setIsLoading(false))
}

export function* uploadFrontlineUser(action) {
  try {
    const { payload, onClose, user_type } = action.payload
    const { data } = yield call(axios.post, `${baseUrl}/super-admin/`, payload)

    if (data.success) {
      toast.success("User has been added", {
        position: "bottom-left",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: false,
        draggable: false,
        progress: undefined,
        theme: "dark"
      })
      onClose()
      let params = `page=1&order_by=full_name`
      if (user_type && user_type !== "") {
        params += `&user_type=${user_type}`
      }
      yield put(appActions.setIsLoading(true))
      const { data: newData } = yield call(axios.get, `${baseUrl}/super-admin/users?${params}`)
      if (newData.success) {
        yield put(
          slice.actions.setFrontlineUserList({
            totalPages: newData?.data?.pages,
            data: newData?.data.results || []
          })
        )
      }
    }
  } catch (e) {
    console.log(e)
  }
  yield put(appActions.setIsLoading(false))
}

export function* deleteUser(action) {
  try {
    const { user_type, page } = action.payload
    yield put(appActions.setIsLoading(true))
    const id = yield select((store) => store?.superAdmin?.frontlineUser?.id ?? "")
    const { data } = yield call(axios.delete, `${baseUrl}/user/${id}/`)

    let params = `page=${page}&order_by=full_name`
    if (user_type === "ADMIN") {
      params += "&user_type=ADMIN"
    }
    const { data: newData } = yield call(axios.get, `${baseUrl}/super-admin/users?${params}`)
    if (data.success) {
      yield put(
        slice.actions.setFrontlineUserList({
          totalPages: newData?.data?.pages,
          data: newData?.data.results || []
        })
      )
    }
  } catch (e) {
    console.log(e)
  }
  yield put(appActions.setIsLoading(false))
}

export function* updateUserStatus(action) {
  try {
    yield put(appActions.setIsLoading(true))
    const id = yield select((store) => store?.superAdmin?.frontlineUser?.id ?? "")
    const { activate, source, user_type, currentPage } = action.payload
    const payload = { activate }
    const { data } = yield call(axios.post, `${baseUrl}/super-admin/${id}/activate/`, payload)

    if (data.success) {
      if (source === "view") {
        const { data: user } = yield call(axios.get, `${baseUrl}/super-admin/${id}/`)
        if (user.success) {
          yield put(slice.actions.setFrontlineUserData(user?.data || {}))
        }
      } else {
        let params = `page=${currentPage}&order_by=full_name`
        if (user_type === "ADMIN") {
          params += "&user_type=ADMIN"
        }
        const { data: newData } = yield call(axios.get, `${baseUrl}/super-admin/users?${params}`)

        if (newData?.success) {
          yield put(
            slice.actions.setFrontlineUserList({
              totalPages: newData?.data?.pages,
              data: newData?.data?.results || []
            })
          )
        }
      }
    }
  } catch (e) {
    console.log(e)
  }
  yield put(appActions.setIsLoading(false))
}

export function* uploadFrontlineBulkUser(action) {
  try {
    const headerParams = {
      headers: {
        "Content-Type": "multipart/form-data"
      }
    }

    const { data } = yield call(
      axios.post,
      `${baseUrl}/super-admin/bulk-create/frontline`,
      {
        file: action.payload
      },
      headerParams
    )

    if (data.success) {
      toast.success("Upload Successful", {
        position: "bottom-left",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: false,
        draggable: false,
        progress: undefined,
        theme: "dark"
      })
      let params = `page=1&order_by=full_name`
      const { data: frontlineUser } = yield call(
        axios.get,
        `${baseUrl}/super-admin/users?${params}`
      )
      if (frontlineUser.success)
        yield put(
          slice.actions.setFrontlineUserList({
            totalPages: frontlineUser?.data?.pages,
            data: frontlineUser?.data.results || []
          })
        )
    }
  } catch (e) {
    console.log(e)
  }
}

export function* uploadFrontlineBulkUserAdmin(action) {
  try {
    const headerParams = {
      headers: {
        "Content-Type": "multipart/form-data"
      }
    }

    const { data } = yield call(
      axios.post,
      `${baseUrl}/super-admin/bulk-create/admin`,
      {
        file: action.payload
      },
      headerParams
    )

    if (data.success) {
      toast.success("Upload Successful", {
        position: "bottom-left",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: false,
        draggable: false,
        progress: undefined,
        theme: "dark"
      })

      let params = `page=1&ordering=-hire_date`
      const { data: userAdmin } = yield call(axios.get, `${baseUrl}/user/?${params}`)
      if (userAdmin.success) {
        yield put(
          slice.actions.setAdminUserList({
            totalPages: userAdmin?.data?.pages,
            data: userAdmin?.data.results || []
          })
        )
      }
    }
  } catch (e) {
    console.log(e)
  }
}

export function* getAdminUsersList(action) {
  try {
    yield put(appActions.setIsLoading(true))
    const { page, search, role, status, restaurant, orderBy } = action.payload
    let params = `page=${page}`
    if (search && search !== "") {
      params += `&search=${search}`
    }
    if (role && role !== "All") {
      params += `&role=${role}`
    }
    if (status && status !== "all") {
      params += `&status=${status}`
    }
    if (restaurant && restaurant !== "All") {
      params += `&restaurant=${restaurant}`
    }
    // if (hire_date) {
    //   params += `&hire_date=${hire_date}`
    // }
    if (orderBy) {
      params += `&ordering=${orderBy}`
    }
    const { data } = yield call(axios.get, `${baseUrl}/user/?${params}`)
    if (data.success) {
      yield put(appActions.setIsLoading(false))
      yield put(
        slice.actions.setAdminUserList({
          totalPages: data?.data?.pages,
          data: data?.data.results || []
        })
      )
    }
  } catch (e) {
    console.log(e)
  }
}

export function* uploadAdminUser(action) {
  try {
    const { data } = yield call(axios.post, `${baseUrl}/user/`, action.payload)

    if (data.success) {
      toast.success("User has been added", {
        position: "bottom-left",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: false,
        draggable: false,
        progress: undefined,
        theme: "dark"
      })
    }
  } catch (e) {
    console.log(e)
  }
}

export function* getUserMainList() {
  try {
    yield put(appActions.setIsLoading(true))
    const { data } = yield call(axios.get, `${baseUrl}/user/user-type`)
    if (data.success) {
      yield put(appActions.setAdminUserList(data.data))
    }
  } catch (e) {
    console.log(e)
  }
  yield put(appActions.setIsLoading(false))
}

export function* getRoleUsersList() {
  try {
    yield put(appActions.setIsLoading(true))
    const { data } = yield call(axios.get, `${baseUrl}/user/role/`)
    if (data.success) {
      yield put(appActions.setRolesUserList(data.data))
    }
  } catch (e) {
    console.log(e)
  }
  yield put(appActions.setIsLoading(false))
}

export function* getNewRestaurantList() {
  try {
    yield put(appActions.setIsLoading(true))
    const { data } = yield call(axios.get, `${baseUrl}/super-admin/restaurant/`)
    if (data.success) {
      yield put(appActions.setNewRestaurantList(data.data.results || []))
    }
  } catch (e) {
    console.log(e)
  }
  yield put(appActions.setIsLoading(false))
}

export function* getAdminUsersData() {
  try {
    const id = yield select((store) => store?.superAdmin?.adminUsers?.id ?? "")
    yield put(appActions.setIsLoading(true))

    const { data } = yield call(axios.get, `${baseUrl}/user/${id}/`)
    if (data.success) {
      yield put(appActions.setIsLoading(false))
      yield put(slice.actions.setAdminUserData(data?.data || {}))
    }
  } catch (e) {
    console.log(e)
  }
}

export function* EditAdminUsersData(action) {
  try {
    const id = yield select((store) => store?.superAdmin?.adminUsers?.id ?? "")
    yield put(appActions.setIsLoading(true))

    const { data } = yield call(axios.patch, `${baseUrl}/user/${id}/`, action.payload)
    if (data.success) {
      yield put(appActions.setIsLoading(false))
      const { data } = yield call(axios.get, `${baseUrl}/user/?page=1&ordering=-hire_date`)
      if (data.success) {
        yield put(appActions.setIsLoading(false))
        yield put(
          slice.actions.setAdminUserList({
            totalPages: data?.data?.pages,
            data: data?.data.results || []
          })
        )
      }
      toast.success("Update Successful", {
        position: "bottom-left",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: false,
        draggable: false,
        progress: undefined,
        theme: "dark"
      })
    }
  } catch (e) {
    console.log(e)
  }
}

export function* updateAdminUserStatus(action) {
  try {
    const id = yield select((store) => store?.superAdmin?.adminUsers?.id ?? "")
    const payload = { activate: action.payload }
    yield put(appActions.setIsLoading(true))
    const { data } = yield call(axios.post, `${baseUrl}/super-admin/${id}/activate/`, payload)

    if (data.success) {
      yield put(appActions.setIsLoading(false))
      const { data: user } = yield call(axios.get, `${baseUrl}/user/${id}/`)
      if (user.success) {
        yield put(appActions.setIsLoading(false))
        yield put(slice.actions.setAdminUserData(user?.data || {}))
      }
    }
  } catch (e) {
    console.log(e)
  }
}

export function* getDashboardStats() {
  try {
    yield put(appActions.setIsLoading(true))

    const { data } = yield call(axios.get, `${baseUrl}/super-admin/user-count/`)
    if (data.success) {
      yield put(slice.actions.setDashboardStats(data?.data || {}))
    }
  } catch (e) {
    console.log(e)
  }
  yield put(appActions.setIsLoading(false))
}

export function* getAppVersionsList(action) {
  try {
    yield put(appActions.setIsLoading(true))
    const { page, search } = action.payload
    let params = `page=${page}`
    if (search && search !== "") {
      params += `&search=${search}`
    }
    const { data } = yield call(axios.get, `${baseUrl}/version/logs/?${params}`)
    if (data.success) {
      yield put(
        slice.actions.setVersionListData({
          totalPages: data?.data?.pages,
          data: data?.data.results || []
        })
      )
    }
  } catch (e) {
    console.log(e)
  }
  yield put(appActions.setIsLoading(false))
}

export function* addVersionItems(action) {
  try {
    yield put(appActions.setIsLoading(true))
    const { data } = yield call(axios.post, `${baseUrl}/version/logs/`, action.payload)
    if (data.success) {
      const { data: newData } = yield call(axios.get, `${baseUrl}/version/logs`)
      if (newData.success) {
        yield put(
          slice.actions.setVersionListData({
            totalPages: newData?.data?.pages,
            data: newData?.data.results || []
          })
        )
      }
    }
  } catch (e) {
    console.log(e)
  }
  yield put(appActions.setIsLoading(false))
}

export function* getVersionData() {
  const id = yield select((store) => store?.superAdmin?.versionId ?? "")
  try {
    yield put(appActions.setIsLoading(true))
    const { data } = yield call(axios.get, `${baseUrl}/version/logs/${id}`)
    if (data.success) {
      yield put(slice.actions.setVersiondata(data?.data))
    }
  } catch (e) {
    console.log(e)
  }
  yield put(appActions.setIsLoading(false))
}

export function* updateVersionItem(action) {
  const id = yield select((store) => store?.superAdmin?.versionId ?? "")
  try {
    yield put(appActions.setIsLoading(true))
    const { data } = yield call(axios.patch, `${baseUrl}/version/logs/${id}`, action.payload)
    if (data.success) {
      const { data: newData } = yield call(axios.get, `${baseUrl}/version/logs`)
      if (newData.success) {
        yield put(
          slice.actions.setVersionListData({
            totalPages: newData?.data?.pages,
            data: newData?.data.results || []
          })
        )
      }
    }
  } catch (e) {
    console.log(e)
  }
  yield put(appActions.setIsLoading(false))
}

export function* deleteVersionItem() {
  const id = yield select((store) => store?.superAdmin?.versionId ?? "")
  try {
    yield put(appActions.setIsLoading(true))
    yield call(axios.delete, `${baseUrl}/version/logs/${id}`)
    const { data: newData } = yield call(axios.get, `${baseUrl}/version/logs`)
    if (newData.success) {
      yield put(
        slice.actions.setVersionListData({
          totalPages: newData?.data?.pages,
          data: newData?.data.results || []
        })
      )
      yield put(slice.actions.setVersionID(null))
    }
  } catch (e) {
    console.log(e)
  }
  yield put(appActions.setIsLoading(false))
}

export function* addNotification(action) {
  try {
    yield put(appActions.setIsLoading(true))
    const { data } = yield call(axios.post, `${baseUrl}/notifications/`, action.payload)
    if (data.success) {
      toast.success("Notification has been added successfully", {
        position: "bottom-left",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: false,
        draggable: false,
        progress: undefined,
        theme: "dark"
      })
      let params = `page=1&ordering=-scheduled_date`
      const { data: newData } = yield call(axios.get, `${baseUrl}/notifications/?${params}`)
      if (newData.success) {
        yield put(
          slice.actions.setNotificationList({
            totalPages: newData?.data?.pages,
            data: newData?.data?.results || []
          })
        )
      }
    }
  } catch (e) {
    console.log(e)
  }
  yield put(appActions.setIsLoading(false))
}

export function* getNotificationList(action) {
  try {
    yield put(appActions.setIsLoading(true))
    const { page, orderBy } = action.payload
    let params = `page=${page}`
    if (orderBy) {
      params += `&ordering=${orderBy}`
    }
    const { data } = yield call(axios.get, `${baseUrl}/notifications/?${params}`)
    if (data.success) {
      yield put(
        slice.actions.setNotificationList({
          totalPages: data?.data?.pages,
          data: data?.data?.results || []
        })
      )
    }
  } catch (e) {
    console.log(e)
  }
  yield put(appActions.setIsLoading(false))
}

export function* deleteNotification(action) {
  try {
    yield put(appActions.setIsLoading(true))
    const { page, id } = action.payload
    yield call(axios.delete, `${baseUrl}/notifications/${id}`)
    let params = `page=${page}&ordering=-scheduled_date`
    const { data: newData } = yield call(axios.get, `${baseUrl}/notifications/?${params}`)
    if (newData.success) {
      yield put(
        slice.actions.setNotificationList({
          totalPages: newData?.data?.pages,
          data: newData?.data?.results || []
        })
      )
    }
  } catch (e) {
    console.log(e)
  }
  yield put(appActions.setIsLoading(false))
}

export function* sendNotification(action) {
  try {
    const { data } = yield call(axios.post, `${baseUrl}/notifications/trigger/`, action.payload)
    if (data.success) {
      toast.success("Notification has been sent", {
        position: "bottom-left",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: false,
        draggable: false,
        progress: undefined,
        theme: "dark"
      })
      let params = `page=1&ordering=-scheduled_date`
      yield put(appActions.setIsLoading(true))
      const { data: newData } = yield call(axios.get, `${baseUrl}/notifications/?${params}`)
      if (newData.success) {
        yield put(
          slice.actions.setNotificationList({
            totalPages: newData?.data?.pages,
            data: newData?.data?.results || []
          })
        )
      }
    }
  } catch (e) {
    console.log(e)
  }
  yield put(appActions.setIsLoading(false))
}

export function* EditNotificationData(action) {
  try {
    const id = yield select((store) => store?.superAdmin?.notifications?.id ?? "")
    yield put(appActions.setIsLoading(true))
    const { page } = action.payload
    const { data } = yield call(axios.patch, `${baseUrl}/notifications/${id}/`, action.payload)
    if (data.success) {
      toast.success("Update Successful", {
        position: "bottom-left",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: false,
        draggable: false,
        progress: undefined,
        theme: "dark"
      })
      let params = `page=${page}&ordering=-scheduled_date`
      const { data: newData } = yield call(axios.get, `${baseUrl}/notifications/?${params}`)
      if (newData.success) {
        yield put(
          slice.actions.setNotificationList({
            totalPages: newData?.data?.pages,
            data: newData?.data?.results || []
          })
        )
      }
    }
  } catch (e) {
    console.log(e)
  }
  yield put(appActions.setIsLoading(false))
}

export function* getNotifications() {
  const id = yield select((store) => store?.superAdmin?.notifications?.id ?? "")
  try {
    yield put(appActions.setIsLoading(true))
    const { data } = yield call(axios.get, `${baseUrl}/notifications/${id}`)
    if (data.success) {
      yield put(slice.actions.setNotificationData(data.data))
    }
  } catch (e) {
    console.log(e)
  }
  yield put(appActions.setIsLoading(false))
}

export function* editNotification(action) {
  const id = yield select((store) => store?.superAdmin?.notifications?.id ?? "")
  try {
    const { data } = yield call(axios.patch, `${baseUrl}/notifications/${id}`, action.payload)
    if (data.success) {
      toast.success("Notification has been updated", {
        position: "bottom-left",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: false,
        draggable: false,
        progress: undefined,
        theme: "dark"
      })
      let params = `page=1&ordering=-scheduled_date`
      yield put(appActions.setIsLoading(true))
      const { data: newData } = yield call(axios.get, `${baseUrl}/notifications/?${params}`)
      yield put(slice.actions.setNotificationID(null))
      if (newData.success) {
        yield put(
          slice.actions.setNotificationList({
            totalPages: newData?.data?.pages,
            data: newData?.data?.results || []
          })
        )
      }
    }
  } catch (e) {
    console.log(e)
  }
  yield put(appActions.setIsLoading(false))
}

export function* uploadNotificationImage(action) {
  try {
    yield put(appActions.setIsLoading(true))
    const { data } = yield call(axios.post, `${baseUrl}/trivia/media/`, action.payload)
    if (data.success) {
      yield put(slice.actions.setNotificationImageId(data.data.id))
    }
  } catch (e) {
    console.log(e)
  }
  yield put(appActions.setIsLoading(false))
}

export function* getGiftCardList(action) {
  try {
    yield put(appActions.setIsLoading(true))
    const { page, giftCard_type } = action.payload

    const { data } = yield call(
      axios.get,
      `${baseUrl}/frontline/gift-card/?page=${page}${
        giftCard_type && giftCard_type !== "All" ? `&card_type=${giftCard_type}` : ""
      }`
    )
    if (data.success) {
      yield put(
        slice.actions.setGiftCardList({
          totalPages: data?.data?.pages,
          data: data?.data?.results || []
        })
      )
    }
  } catch (e) {
    console.log(e)
  }
  yield put(appActions.setIsLoading(false))
}

export function* getGiftCard() {
  const id = yield select((store) => store?.superAdmin?.giftCards?.id ?? "")
  try {
    yield put(appActions.setIsLoading(true))
    const { data } = yield call(axios.get, `${baseUrl}/frontline/${id}/gift-card`)
    if (data.success) {
      yield put(slice.actions.setGiftCardData(data.data))
    }
  } catch (e) {
    console.log(e)
  }
  yield put(appActions.setIsLoading(false))
}

export function* addGiftCard(action) {
  try {
    const { payload, onClose } = action.payload
    const giftCard_type = yield select((store) => store.app?.filters?.giftCard_type)
    let params = `page=1`
    if (giftCard_type && giftCard_type !== "All") {
      params += `&card_type=${giftCard_type}`
    }
    const { data } = yield call(axios.post, `${baseUrl}/frontline/gift-card/`, payload)
    if (data.success) {
      onClose()
      toast.success("Prize has been added", {
        position: "bottom-left",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: false,
        draggable: false,
        progress: undefined,
        theme: "dark"
      })
      yield put(appActions.setIsLoading(true))
      const { data: newData } = yield call(axios.get, `${baseUrl}/frontline/gift-card/?${params}`)
      if (newData.success) {
        yield put(
          slice.actions.setGiftCardList({
            totalPages: newData?.data?.pages,
            data: newData?.data?.results || []
          })
        )
      }
    }
  } catch (e) {
    console.log(e)
  }
  yield put(appActions.setIsLoading(false))
}

export function* deleteGiftCard(action) {
  try {
    yield put(appActions.setIsLoading(true))
    const giftCard_type = yield select((store) => store.app?.filters?.giftCard_type)
    const { id, page } = action.payload
    let params = `page=${page}`
    if (giftCard_type && giftCard_type !== "All") {
      params = `&card_type=${giftCard_type}`
    }
    yield call(axios.delete, `${baseUrl}/frontline/${id}/gift-card`)
    const { data: newData } = yield call(axios.get, `${baseUrl}/frontline/gift-card/?${params}`)
    if (newData.success) {
      yield put(
        slice.actions.setGiftCardList({
          totalPages: newData?.data?.pages,
          data: newData?.data?.results || []
        })
      )
    }
  } catch (e) {
    console.log(e)
  }
  yield put(appActions.setIsLoading(false))
}

export function* EditGiftCard(action) {
  const id = yield select((store) => store?.superAdmin?.giftCards?.id ?? "")
  const giftCard_type = yield select((store) => store.app?.filters?.giftCard_type)
  let params = `page=1`
  if (giftCard_type && giftCard_type !== "All") {
    params = `&card_type=${giftCard_type}`
  }
  try {
    const { payload, onClose } = action.payload
    const { data } = yield call(axios.patch, `${baseUrl}/frontline/${id}/gift-card`, payload)
    if (data.success) {
      onClose()
      toast.success("Prize has been edited", {
        position: "bottom-left",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: false,
        draggable: false,
        progress: undefined,
        theme: "dark"
      })
      yield put(appActions.setIsLoading(true))
      const { data: newData } = yield call(axios.get, `${baseUrl}/frontline/gift-card/?${params}`)
      yield put(slice.actions.setGiftCardID(null))
      if (newData.success) {
        yield put(
          slice.actions.setGiftCardList({
            totalPages: newData?.data?.pages,
            data: newData?.data?.results || []
          })
        )
      }
    }
  } catch (e) {
    console.log(e)
  }
  yield put(appActions.setIsLoading(false))
}

export function* uploadGiftCardImage(action) {
  try {
    yield put(appActions.setIsLoading(true))
    const { data } = yield call(axios.post, `${baseUrl}/trivia/media/`, action.payload)
    if (data.success) {
      yield put(slice.actions.setGiftCardImageId(data.data.id))
    }
  } catch (e) {
    console.log(e)
  }
  yield put(appActions.setIsLoading(false))
}

export function* getGamificationData() {
  try {
    yield put(appActions.setIsLoading(true))
    const { data } = yield call(axios.get, `${baseUrl}/frontline/gamification-cms/`)
    if (data.success) {
      yield put(slice.actions.setGamificationData(data.data))
    }
  } catch (e) {
    console.log(e)
  }
  yield put(appActions.setIsLoading(false))
}

export function* EditGamification(action) {
  try {
    yield put(appActions.setIsLoading(true))

    const { data } = yield call(
      axios.post,
      `${baseUrl}/frontline/gamification-cms/`,
      action?.payload
    )
    if (data.success) {
      const { data: newData } = yield call(axios.get, `${baseUrl}/frontline/gamification-cms/`)
      if (newData.success) {
        yield put(slice.actions.setGamificationData(newData?.data))
      }
    }
  } catch (e) {
    console.log(e)
  }
  yield put(appActions.setIsLoading(false))
}

export function* getEventData(action) {
  try {
    const { orderBy } = action.payload
    let params
    if (orderBy) {
      params = `sort_by=${orderBy}`
    }
    yield put(appActions.setIsLoading(true))
    const { data } = yield call(axios.get, `${baseUrl}/frontline/cms/event/?${params}`)
    if (data.success) {
      yield put(slice.actions.setEventList(data.data))
    }
  } catch (e) {
    console.log(e)
  }
  yield put(appActions.setIsLoading(false))
}

export function* addEvent(action) {
  const isUpdating = yield select((store) => store.app?.isUpdating)
  if (!isUpdating) {
    yield put(appActions.setIsLoading(true))
    try {
      const { payload, onClose } = action.payload
      const { data } = yield call(axios.post, `${baseUrl}/frontline/cms/event/`, payload)
      yield put(appActions.setIsLoading(true))
      if (data.success) {
        onClose()
        toast.success("Event has been successfully added", {
          position: "bottom-left",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: false,
          draggable: false,
          progress: undefined,
          theme: "dark"
        })
        const { data: newData } = yield call(
          axios.get,
          `${baseUrl}/frontline/cms/event/?sort_by=-start_date`
        )
        if (newData.success) {
          yield put(slice.actions.setEventList(newData.data))
        }
      }
    } catch (e) {
      console.log(e)
    }
    yield put(appActions.setIsLoading(false))
  }
}

export function* deleteEvent(action) {
  try {
    yield put(appActions.setIsLoading(true))
    const { id } = action.payload
    yield call(axios.delete, `${baseUrl}/frontline/event/${id}`)
    const { data: newData } = yield call(
      axios.get,
      `${baseUrl}/frontline/cms/event/?sort_by=-start_date`
    )
    if (newData.success) {
      yield put(slice.actions.setEventList(newData.data))
    }
  } catch (e) {
    console.log(e)
  }
  yield put(appActions.setIsLoading(false))
}

export function* getEventDetails() {
  const id = yield select((store) => store?.superAdmin?.eventID ?? "")
  try {
    yield put(appActions.setIsLoading(true))
    const { data } = yield call(axios.get, `${baseUrl}/frontline/event/${id}`)
    if (data.success) {
      yield put(slice.actions.setEventDetails(data.data))
    }
  } catch (e) {
    console.log(e)
  }
  yield put(appActions.setIsLoading(false))
}

export function* editEvent(action) {
  const isUpdating = yield select((store) => store.app?.isUpdating)
  if (!isUpdating) {
    yield put(appActions.setIsLoading(true))
    try {
      const { payload, onClose } = action.payload
      const id = yield select((store) => store?.superAdmin?.eventID ?? "")
      const { data } = yield call(axios.patch, `${baseUrl}/frontline/event/${id}`, payload)
      if (data.success) {
        onClose()
        toast.success("Event has been successfully updated", {
          position: "bottom-left",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: false,
          draggable: false,
          progress: undefined,
          theme: "dark"
        })
        const { data: newData } = yield call(
          axios.get,
          `${baseUrl}/frontline/cms/event/?sort_by=-start_date`
        )
        if (newData.success) {
          yield put(slice.actions.setEventList(newData.data))
        }
      }
    } catch (e) {
      console.log(e)
    }
    yield put(appActions.setIsLoading(false))
  }
}

export function* getMenuImage() {
  yield put(appActions.setIsLoading(true))
  try {
    const { data } = yield call(axios.get, `${baseUrl}/frontline/menu/categories`)
    if (data.success) {
      yield put(slice.actions.setMenuImageList(data.data))
    }
  } catch (e) {
    console.log(e)
  }
  yield put(appActions.setIsLoading(false))
}

export function* addMenuImage(action) {
  const isUpdating = yield select((store) => store.app?.isUpdating)
  if (!isUpdating) {
    yield put(appActions.setIsLoading(true))
    try {
      const { payload, onClose } = action.payload
      const { data } = yield call(
        axios.patch,
        `${baseUrl}/frontline/menu-categories/bulk-update/`,
        payload
      )
      if (data.success) {
        onClose()
        const { data: newData } = yield call(axios.get, `${baseUrl}/frontline/menu/categories`)
        if (newData.success) {
          yield put(slice.actions.setMenuImageList(newData.data))
        }
      }
    } catch (e) {
      console.log(e)
    }
    yield put(appActions.setIsLoading(false))
  }
}

export function* uploadMenuImage(action) {
  yield put(appActions.setIsLoading(true))
  try {
    const { data } = yield call(axios.post, `${baseUrl}/trivia/media/`, action.payload.data)
    if (data.success) {
      yield put(
        slice.actions.setMenuImage({
          index: action.payload.index,
          id: data.data.id
        })
      )
    }
  } catch (e) {
    console.log(e)
  }
  yield put(appActions.setIsLoading(false))
}

export function* downloadMenuTemplate(action) {
  const { selectedMenu, sub_category } = action.payload
  let params = `category=${selectedMenu}`
  if (selectedMenu === "Bar Menu" && sub_category && sub_category !== "") {
    params += `&sub_category=${sub_category}`
  }
  yield put(appActions.setLoadingData(true))
  try {
    const { data } = yield call(axios.get, `${baseUrl}/frontline/menu/template?${params}`)
    if (data.success) {
      yield put(slice.actions.setDownloadMenuTemplate(data.data.template_url))
    }
  } catch (e) {
    console.log(e)
  }
  yield put(appActions.setIsLoading(false))
}

export function* getDynamicMenuFields(action) {
  try {
    const { category, sub_category } = action.payload
    let categoryParams = category.replace(/&/g, "%26")
    let params = `category=${categoryParams}`

    if (category === "Bar Menu" && sub_category && sub_category !== "") {
      params += `&sub_category=${sub_category}`
    }
    yield put(appActions.setIsLoading(true))
    const { data } = yield call(axios.get, `${baseUrl}/frontline/dynamic-fields/?${params}`)
    if (data.success) {
      // Some categories (e.g. "Wine By Bottle") can come back with `fields` as a
      // non-array shape; coerce to an array so every consumer's .reduce/.forEach
      // (AddMenuItems, EditMenu, ReviewMenu, superAdmin) never throws.
      const fields = data.data?.fields
      const nonAiFields = data.data?.non_ai_fields
      yield put(slice.actions.setMenuFields(Array.isArray(fields) ? fields : []))
      yield put(slice.actions.setNonAiFields(Array.isArray(nonAiFields) ? nonAiFields : []))
    }
  } catch (e) {
    console.log(e)
  }
  yield put(appActions.setIsLoading(false))
}

export function* createDynamicMenuFields(action) {
  try {
    const { payload, category, onClose, barCategory } = action.payload
    let categoryParams = category.replace(/&/g, "%26")
    let params = `category=${categoryParams}`
    if (category === "Bar Menu" && barCategory && barCategory !== "") {
      params += `&sub_category=${barCategory}`
    } else {
      params += `&sub_category=null`
    }
    yield put(appActions.setIsLoading(true))
    const { data } = yield call(axios.post, `${baseUrl}/frontline/dynamic-fields/`, payload)
    if (data.success) {
      onClose()
      const { data: newData } = yield call(
        axios.get,
        `${baseUrl}/frontline/dynamic-fields/?${params}`
      )
      if (newData.success) {
        yield put(slice.actions.setMenuFields(newData.data?.fields || []))
        yield put(slice.actions.setNonAiFields(newData.data?.non_ai_fields || []))
      }
      const { data: templateDate } = yield call(
        axios.get,
        `${baseUrl}/frontline/menu/template?${params}`
      )
      if (templateDate.success) {
        yield put(slice.actions.setDownloadMenuTemplate(templateDate.data.template_url))
      }
    }
  } catch (e) {
    console.log(e)
  }
  yield put(appActions.setIsLoading(false))
}

export function* deleteMenuField(action) {
  try {
    const { id, category, barCategory } = action.payload
    let categoryParams = category.replace(/&/g, "%26")
    let params = `category=${categoryParams}`
    if (category === "Bar Menu" && barCategory && barCategory !== "") {
      params += `&sub_category=${barCategory}`
    }
    yield put(appActions.setIsLoading(true))
    yield call(axios.delete, `${baseUrl}/frontline/dynamic-fields/${id}/`)
    const { data: newData } = yield call(
      axios.get,
      `${baseUrl}/frontline/dynamic-fields/?${params}`
    )
    if (newData.success) {
      yield put(slice.actions.setMenuFields(newData.data?.fields || []))
      yield put(slice.actions.setNonAiFields(newData.data?.non_ai_fields || []))
    }
  } catch (e) {
    console.log(e)
  }
  yield put(appActions.setIsLoading(false))
}

export function* editDynamicMenuFields(action) {
  try {
    const { payload, category, barCategory } = action.payload
    let categoryParams = category.replace(/&/g, "%26")
    let params = `category=${categoryParams}`
    if (category === "Bar Menu" && barCategory && barCategory !== "") {
      params += `&sub_category=${barCategory}`
    }
    yield put(appActions.setIsLoading(true))
    const { data } = yield call(axios.patch, `${baseUrl}/frontline/dynamic-fields/`, payload)
    if (data.success) {
      const { data: newData } = yield call(
        axios.get,
        `${baseUrl}/frontline/dynamic-fields/?${params}`
      )
      if (newData.success) {
        yield put(slice.actions.setMenuFields(newData.data?.fields || []))
        yield put(slice.actions.setNonAiFields(newData.data?.non_ai_fields || []))
      }
    }
  } catch (e) {
    console.log(e)
  }
  yield put(appActions.setIsLoading(false))
}

export function* sendInvite(action) {
  try {
    const { payload, showSuccessModal } = action.payload
    yield put(appActions.setIsLoading(true))
    const { data } = yield call(axios.post, `${baseUrl}/user/send-invite/`, payload)
    if (data.success) {
      showSuccessModal()
    }
  } catch (e) {
    console.log(e)
  }
  yield put(appActions.setIsLoading(false))
}

export function* getUserRole() {
  yield put(appActions.setIsLoading(true))
  try {
    const { data } = yield call(axios.get, `${baseUrl}/user/job-class/`)
    if (data.success) {
      yield put(slice.actions.setUserRoleList(data?.data))
      let roleList = []
      if (data.data?.length > 0) {
        for (let i of data.data) {
          roleList.push({
            value: i.id,
            label: i.name
          })
        }
      }
      roleList.unshift({ label: "All", value: "All" })
      yield put(slice.actions.setUserRole(roleList))
    }
  } catch (e) {
    console.log(e)
  }
  yield put(appActions.setIsLoading(false))
}

export function* getRoleDetails() {
  yield put(appActions.setIsLoading(true))
  try {
    const id = yield select((store) => store?.superAdmin?.userRoleId ?? "")
    const { data } = yield call(axios.get, `${baseUrl}/user/job-class/${id}/`)
    if (data.success) {
      yield put(slice.actions.setRoleDetails(data?.data))
    }
  } catch (e) {
    console.log(e)
  }
  yield put(appActions.setIsLoading(false))
}

export function* editRoleDetails(action) {
  yield put(appActions.setIsLoading(true))
  try {
    const { payload } = action.payload
    const id = yield select((store) => store?.superAdmin?.userRoleId ?? "")
    const { data } = yield call(axios.patch, `${baseUrl}/user/job-class/${id}/`, payload)
    if (data.success) {
      const { data: newData } = yield call(axios.get, `${baseUrl}/user/job-class/`)
      if (newData.success) {
        yield put(slice.actions.setUserRoleList(newData?.data))
      }
    }
  } catch (e) {
    console.log(e)
  }
  yield put(slice.actions.setRoleDetails(""))
  yield put(appActions.setIsLoading(false))
}

export function* addRoleDetails(action) {
  yield put(appActions.setIsLoading(true))
  try {
    const { payload } = action.payload
    const { data } = yield call(axios.post, `${baseUrl}/user/job-class/`, payload)
    if (data.success) {
      const { data: newData } = yield call(axios.get, `${baseUrl}/user/job-class/`)
      if (newData.success) {
        yield put(slice.actions.setUserRoleList(newData?.data))
      }
    }
  } catch (e) {
    console.log(e)
  }
  yield put(slice.actions.setRoleDetails(""))
  yield put(appActions.setIsLoading(false))
}

export function* deleteRoleDetails() {
  yield put(appActions.setIsLoading(true))
  try {
    const id = yield select((store) => store?.superAdmin?.userRoleId ?? "")
    const { data } = yield call(axios.delete, `${baseUrl}/user/job-class/${id}/`)
    if (data.success) {
      const { data: newData } = yield call(axios.get, `${baseUrl}/user/job-class/`)
      if (newData.success) {
        yield put(slice.actions.setUserRoleList(newData?.data))
      }
    }
  } catch (e) {
    console.log(e)
  }
  yield put(slice.actions.setRoleDetails(""))
  yield put(appActions.setIsLoading(false))
}

export function* addMenuCategory(action) {
  yield put(appActions.setIsLoading(true))
  const { payload, onClose } = action.payload
  try {
    const { data } = yield call(axios.post, `${baseUrl}/frontline/menu/categories`, payload)
    if (data.success) {
      onClose()
      const { data: newData } = yield call(axios.get, `${baseUrl}/frontline/menu/categories`)
      if (newData.success) {
        yield put(slice.actions.setMenuImageList(newData.data))
      }
    }
  } catch (e) {
    console.log(e)
  }
  yield put(appActions.setIsLoading(false))
}

export function* changeMenuOrder(action) {
  yield put(appActions.setIsLoading(true))
  try {
    const { data } = yield call(
      axios.post,
      `${baseUrl}/frontline/menu/categories/order/`,
      action.payload
    )
    if (data.success) {
      const { data: newData } = yield call(axios.get, `${baseUrl}/frontline/menu/categories`)
      if (newData.success) {
        yield put(slice.actions.setMenuImageList(newData?.data))
      }
    }
  } catch (e) {
    console.log(e)
  }
  yield put(appActions.setIsLoading(false))
}

export function* getMenuCategoryDetails(action) {
  yield put(appActions.setIsLoading(true))
  try {
    const { data } = yield call(axios.get, `${baseUrl}/frontline/menu/categories/${action.payload}`)
    if (data.success) {
      yield put(slice.actions.setMenuCategoryDetails(data?.data))
    }
  } catch (e) {
    console.log(e)
  }
  yield put(appActions.setIsLoading(false))
}

export function* editMenuCategoryDetails(action) {
  yield put(appActions.setIsLoading(true))
  const { payload, onClose, id } = action.payload
  try {
    const { data } = yield call(axios.patch, `${baseUrl}/frontline/menu/categories/${id}/`, payload)
    if (data.success) {
      onClose()
      const { data: newData } = yield call(axios.get, `${baseUrl}/frontline/menu/categories`)
      if (newData.success) {
        yield put(slice.actions.setMenuImageList(newData?.data))
      }
    }
  } catch (e) {
    console.log(e)
  }
  yield put(appActions.setIsLoading(false))
}

export function* deleteMenuCategory(action) {
  yield put(appActions.setIsLoading(true))
  try {
    const { id, setSelectedMenuId, setSelectedMenu } = action.payload
    const { data } = yield call(axios.delete, `${baseUrl}/frontline/menu/categories/${id}/`)
    if (data.success) {
      const { data: newData } = yield call(axios.get, `${baseUrl}/frontline/menu/categories`)
      if (newData.success) {
        yield put(slice.actions.setMenuImageList(newData?.data))
        setSelectedMenuId(
          newData?.data[0]?.name === "Spirits" ? newData?.data[1]?.id : newData?.data[0]?.id
        )
        setSelectedMenu(
          newData?.data[0]?.name === "Spirits" ? newData?.data[1]?.name : newData?.data[0]?.name
        )
      }
    }
  } catch (e) {
    console.log(e)
  }
  yield put(appActions.setIsLoading(false))
}

export function* getRecommendationCategoryList() {
  yield put(appActions.setIsLoading(true))
  try {
    const { data } = yield call(axios.get, `${baseUrl}/weekly/role-recommended-category`)
    if (data.success) {
      yield put(slice.actions.setRecommendationCategoryList(data?.data))
    }
  } catch (e) {
    console.log(e)
  }
  yield put(appActions.setIsLoading(false))
}

export function* getRecommendedCategoryDetails(action) {
  yield put(appActions.setIsLoading(true))
  try {
    const { data } = yield call(axios.get, `${baseUrl}/weekly/roles-by-category/${action.payload}`)
    if (data.success) {
      yield put(slice.actions.setRecommendedCategoryDetails(data?.data))
    }
  } catch (e) {
    console.log(e)
  }
  yield put(appActions.setIsLoading(false))
}

export function* updateRecommendedCategoryDetails(action) {
  yield put(appActions.setIsLoading(true))
  try {
    const { id, payload } = action.payload
    const { data } = yield call(
      axios.patch,
      `${baseUrl}/weekly/role-recommended-category/${id}/`,
      payload
    )
    if (data.success) {
      toast.success("Category updated successfully", {
        position: "bottom-left",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: false,
        draggable: false,
        progress: undefined,
        theme: "dark"
      })
      const { data: newData } = yield call(axios.get, `${baseUrl}/weekly/role-recommended-category`)
      if (newData.success) {
        yield put(slice.actions.setRecommendationCategoryList(newData?.data))
      }
    }
  } catch (e) {
    console.log(e)
  }
  yield put(appActions.setIsLoading(false))
}

export function* getHeaderNotification() {
  yield put(appActions.setIsLoading(true))
  try {
    const { data } = yield call(axios.get, `${baseUrl}/weekly/header-notification/`)
    if (data.success) {
      yield put(slice.actions.setHeaderNotificationData(data?.data))
    }
  } catch (e) {
    console.log(e)
  }
  yield put(appActions.setIsLoading(false))
}

export function* createHeaderNotification(action) {
  yield put(appActions.setIsLoading(true))
  try {
    const { payload, handleRoute } = action.payload
    const { data } = yield call(axios.post, `${baseUrl}/weekly/header-notification/`, payload)
    if (data.success) {
      handleRoute()
      toast.success("Header notification updated successfully", {
        position: "bottom-left",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: false,
        draggable: false,
        progress: undefined,
        theme: "dark"
      })

      const { data: newData } = yield call(axios.get, `${baseUrl}/weekly/header-notification/`)
      if (newData.success) {
        yield put(slice.actions.setHeaderNotificationData(newData?.data))
      }
    }
  } catch (e) {
    console.log(e)
  }
  yield put(appActions.setIsLoading(false))
}

export function* getTilesList() {
  yield put(appActions.setIsLoading(true))
  try {
    const { data } = yield call(axios.get, `${baseUrl}/weekly/tile-options/`)
    if (data.success) {
      yield put(slice.actions.setTilesList(data?.data))
    }
  } catch (e) {
    console.log(e)
  }
  yield put(appActions.setIsLoading(false))
}

export function* createTile(action) {
  yield put(appActions.setIsLoading(true))
  try {
    const { payload, handleClose } = action.payload
    const { data } = yield call(axios.post, `${baseUrl}/weekly/tile-options/`, payload)
    if (data.success) {
      handleClose()
      const { data: newData } = yield call(axios.get, `${baseUrl}/weekly/tile-options/`)
      if (newData.success) {
        yield put(slice.actions.setTilesList(newData?.data))
      }
    }
  } catch (e) {
    console.log(e)
  }
  yield put(appActions.setIsLoading(false))
}

export function* updateTile(action) {
  yield put(appActions.setIsLoading(true))
  try {
    const { id, payload, handleClose } = action.payload
    const { data } = yield call(axios.patch, `${baseUrl}/weekly/tile/update/${id}/`, payload)
    if (data.success) {
      handleClose()
      const { data: newData } = yield call(axios.get, `${baseUrl}/weekly/tile-options/`)
      if (newData.success) {
        yield put(slice.actions.setTilesList(newData?.data))
      }
    }
  } catch (e) {
    console.log(e)
  }
  yield put(appActions.setIsLoading(false))
}

export function* deleteTile(action) {
  yield put(appActions.setIsLoading(true))
  try {
    const { id, handleClose } = action.payload
    const { data } = yield call(axios.delete, `${baseUrl}/weekly/tile/update/${id}/`)
    if (data.success) {
      handleClose()
      const { data: newData } = yield call(axios.get, `${baseUrl}/weekly/tile-options/`)
      if (newData.success) {
        yield put(slice.actions.setTilesList(newData?.data))
      }
    }
  } catch (e) {
    console.log(e)
  }
  yield put(appActions.setIsLoading(false))
}

export function* reorderTiles(action) {
  yield put(appActions.setIsLoading(true))
  try {
    const { data } = yield call(axios.post, `${baseUrl}/weekly/tile/order/`, action.payload)
    if (data.success) {
      const { data: newData } = yield call(axios.get, `${baseUrl}/weekly/tile-options/`)
      if (newData.success) {
        yield put(slice.actions.setTilesList(newData?.data))
      }
    }
  } catch (e) {
    console.log(e)
  }
  yield put(appActions.setIsLoading(false))
}

export function* enableDisableTiles(action) {
  yield put(appActions.setIsLoading(true))
  try {
    const { payload, handleRoute } = action.payload
    const { data } = yield call(axios.patch, `${baseUrl}/weekly/tile/enable-disable/`, payload)
    if (data.success) {
      handleRoute()
    }
  } catch (e) {
    console.log(e)
  }
  yield put(appActions.setIsLoading(false))
}

export function* getTileDetails(action) {
  yield put(appActions.setIsLoading(true))
  try {
    const { data } = yield call(axios.patch, `${baseUrl}/weekly/tile/update/${action.payload}/`)
    if (data.success) {
      yield put(slice.actions.setTileDetails(data?.data))
    }
  } catch (e) {
    console.log(e)
  }
  yield put(appActions.setIsLoading(false))
}

export function* getWeeklyCategory() {
  yield put(appActions.setIsLoading(true))
  try {
    const { data } = yield call(axios.get, `${baseUrl}/weekly/categories/?web=true`)
    if (data.success) {
      yield put(slice.actions.setWeeklyCategory(data?.data))
    }
  } catch (e) {
    console.log(e)
  }
  yield put(appActions.setIsLoading(false))
}

export function* uploadWeeklyCategoryImage(action) {
  yield put(appActions.setIsLoading(true))
  try {
    const { type } = action.payload
    const { data } = yield call(axios.post, `${baseUrl}/trivia/media/`, action.payload.data)
    if (data.success) {
      if (type) {
        if (type === "image") {
          yield put(slice.actions.setWeeklyCategoryImage(data.data.id))
        } else {
          yield put(slice.actions.setWeeklyCategoryIcon(data.data.id))
        }
      } else {
        yield put(
          slice.actions.setMenuImage({
            index: action.payload.index,
            id: data.data.id
          })
        )
      }
    }
  } catch (e) {
    console.log(e)
  }
  yield put(appActions.setIsLoading(false))
}

export function* addWeeklyCategoryImage(action) {
  yield put(appActions.setIsLoading(true))
  try {
    const { onClose, payload } = action.payload
    const { data } = yield call(axios.patch, `${baseUrl}/weekly/categories/`, payload)
    if (data.success) {
      onClose()
      const { data: newData } = yield call(axios.get, `${baseUrl}/weekly/categories/?web=true`)
      if (newData.success) {
        yield put(slice.actions.setWeeklyCategory(newData?.data))
      }
    }
  } catch (e) {
    console.log(e)
  }
  yield put(appActions.setIsLoading(false))
}

export function* addWeeklyCategory(action) {
  yield put(appActions.setIsLoading(true))
  try {
    const { onClose, payload } = action.payload
    const { data } = yield call(axios.post, `${baseUrl}/weekly/categories/`, payload)
    if (data.success) {
      onClose()
      yield put(slice.actions.setWeeklyCategoryIcon(""))
      yield put(slice.actions.setWeeklyCategoryImage(""))
      const { data: newData } = yield call(axios.get, `${baseUrl}/weekly/categories/?web=true`)
      if (newData.success) {
        yield put(slice.actions.setWeeklyCategory(newData?.data))
      }
    }
  } catch (e) {
    console.log(e)
  }
  yield put(appActions.setIsLoading(false))
}

export function* editWeeklyCategory(action) {
  yield put(appActions.setIsLoading(true))
  try {
    const { onClose, payload, id } = action.payload
    const { data } = yield call(axios.patch, `${baseUrl}/weekly/categories/${id}/`, payload)
    if (data.success) {
      onClose()
      yield put(slice.actions.setWeeklyCategoryIcon(""))
      yield put(slice.actions.setWeeklyCategoryImage(""))
      const { data: newData } = yield call(axios.get, `${baseUrl}/weekly/categories/?web=true`)
      if (newData.success) {
        yield put(slice.actions.setWeeklyCategory(newData?.data))
      }
    }
  } catch (e) {
    console.log(e)
  }
  yield put(appActions.setIsLoading(false))
}
export function* getAdvertisements() {
  yield put(appActions.setIsLoading(true))
  try {
    const { data } = yield call(axios.get, `${baseUrl}/weekly/advertisements/`)
    if (data.success) {
      yield put(slice.actions.setAdvertisements(data?.data))
    }
  } catch (e) {
    console.log(e)
  }
  yield put(appActions.setIsLoading(false))
}

export function* getAdvertisementDetails(action) {
  yield put(appActions.setIsLoading(true))
  try {
    const { id } = action.payload
    const { data } = yield call(axios.get, `${baseUrl}/weekly/advertisements/${id}/`)
    if (data.success) {
      yield put(slice.actions.setAdvertisementDetails(data?.data))
    }
  } catch (e) {
    console.log(e)
  }
  yield put(appActions.setIsLoading(false))
}

export function* addAdvertisements(action) {
  yield put(appActions.setIsLoading(true))
  try {
    const { onClose, payload } = action.payload
    const { data } = yield call(axios.post, `${baseUrl}/weekly/advertisements/`, payload)
    if (data.success) {
      onClose()
      const { data: newData } = yield call(axios.get, `${baseUrl}/weekly/advertisements/`)
      if (newData.success) {
        yield put(slice.actions.setAdvertisements(newData?.data))
      }
    }
  } catch (e) {
    console.log(e)
  }
  yield put(appActions.setIsLoading(false))
}

export function* updateAdvertisements(action) {
  yield put(appActions.setIsLoading(true))
  try {
    const { onClose, id, payload } = action.payload
    const { data } = yield call(axios.patch, `${baseUrl}/weekly/advertisements/${id}/`, payload)
    if (data.success) {
      onClose()
      const { data: newData } = yield call(axios.get, `${baseUrl}/weekly/advertisements/`)
      if (newData.success) {
        yield put(slice.actions.setAdvertisements(newData?.data))
      }
    }
  } catch (e) {
    console.log(e)
  }
  yield put(appActions.setIsLoading(false))
}

export function* deleteAdvertisements(action) {
  yield put(appActions.setIsLoading(true))
  try {
    const { id } = action.payload
    const { data } = yield call(axios.delete, `${baseUrl}/weekly/advertisements/${id}/`)
    if (data.success) {
      const { data: newData } = yield call(axios.get, `${baseUrl}/weekly/advertisements/`)
      if (newData.success) {
        yield put(slice.actions.setAdvertisements(newData?.data))
      }
    }
  } catch (e) {
    console.log(e)
  }
  yield put(appActions.setIsLoading(false))
}

export function* uploadPrivacyPolicyDocument(action) {
  try {
    yield put(appActions.setIsLoading(true))
    const { file, title, description, onClose } = action.payload
    const formData = new FormData()
    formData.append("media", file)
    formData.append("media_type", "IMAGE")
    formData.append("content_type", "application/pdf")
    const { data } = yield call(axios.post, `${baseUrl}/trivia/media/`, formData)
    if (data.success) {
      const payload = {
        title,
        description,
        pnp_id: data?.data?.id
      }
      const { data: policyResponse } = yield call(
        axios.post,
        `${baseUrl}/frontline/policy-procedure/`,
        payload
      )
      if (policyResponse.success) {
        if (typeof onClose === "function") {
          onClose()
        }
        const { data: newData } = yield call(axios.get, `${baseUrl}/frontline/policy-procedure/`)
        if (newData.success) {
          yield put(slice.actions.setPrivacyPolicy(newData?.data))
        }
      }
    }
  } catch (e) {
    console.log(e)
  }
  yield put(appActions.setIsLoading(false))
}

export function* getPrivacyPolicy() {
  yield put(appActions.setIsLoading(true))
  try {
    const { data } = yield call(axios.get, `${baseUrl}/frontline/policy-procedure/`)
    if (data.success) {
      yield put(slice.actions.setPrivacyPolicy(data?.data || []))
    }
  } catch (e) {
    console.log(e)
  }
  yield put(appActions.setIsLoading(false))
}

export function* deleteNotableVip(action) {
  try {
    yield put(appActions.setIsLoading(true))
    const { id } = action.payload
    yield call(axios.delete, `${baseUrl}/frontline/food-item/${id}`)
    const { data: newData } = yield call(axios.get, `${baseUrl}/vip/notable/?all=True`)
    if (newData.success) {
      yield put(
        slice.actions.setNotableVips({
          data: newData?.data?.notable_vips || [],
          count: newData?.data?.count || 0
        })
      )
    }
  } catch (e) {
    console.log(e)
  }
  yield put(appActions.setIsLoading(false))
}

export function* getNotableVips(action) {
  try {
    yield put(appActions.setIsLoading(true))
    const { startDate, endDate } = action.payload
    let params = ``
    if (startDate) {
      params += `?start_date=${startDate}`
    }
    if (endDate) {
      params += `&end_date=${endDate}`
    }
    const { data } = yield call(axios.get, `${baseUrl}/vip/notable/${params}`)
    if (data?.success) {
      yield put(
        slice.actions.setNotableVips({
          data: data?.data?.notable_vips || [],
          count: data?.data?.count || 0
        })
      )
    }
  } catch (e) {
    console.log(e)
  }
  yield put(appActions.setIsLoading(false))
}

export function* getNotableUsers() {
  try {
    yield put(appActions.setIsLoading(true))
    const { data } = yield call(axios.get, `${baseUrl}/vip/notable-users/`)
    if (data.success) {
      yield put(slice.actions.setNotableUsers(data?.data || []))
    }
  } catch (e) {
    console.log(e)
  }
  yield put(appActions.setIsLoading(false))
}

export function* updateNotableUsers(action) {
  try {
    yield put(appActions.setIsLoading(true))
    const { data } = yield call(
      axios.patch,
      `${baseUrl}/vip/notable-users/bulk-update/`,
      action.payload
    )
    if (data.success) {
      const { data: newData } = yield call(axios.get, `${baseUrl}/vip/notable-users/`)
      if (newData.success) {
        yield put(slice.actions.setNotableUsers(newData?.data || []))
      }
    }
  } catch (e) {
    console.log(e)
  }
  yield put(appActions.setIsLoading(false))
}

export function* getRewardsPermissions() {
  try {
    yield put(appActions.setIsLoading(true))
    const { data } = yield call(axios.get, `${baseUrl}/rewards/admin/email-permissions/`)
    if (data.success) {
      yield put(slice.actions.setRewardsPermissions(data?.data || []))
    }
  } catch (e) {
    console.log(e)
  }
  yield put(appActions.setIsLoading(false))
}

export function* updateRewardsPermissions(action) {
  try {
    yield put(appActions.setIsLoading(true))
    const { data } = yield call(
      axios.patch,
      `${baseUrl}/rewards/admin/email-permissions/bulk-update/`,
      action.payload
    )
    if (data.success) {
      const { data: newData } = yield call(axios.get, `${baseUrl}/rewards/admin/email-permissions/`)
      if (newData.success) {
        yield put(slice.actions.setRewardsPermissions(newData?.data || []))
      }
    }
  } catch (e) {
    console.log(e)
  }
  yield put(appActions.setIsLoading(false))
}

export function* getVipDetails(action) {
  try {
    yield put(appActions.setIsLoading(true))
    const { id } = action.payload
    const { data } = yield call(axios.get, `${baseUrl}/frontline/food-item/${id}`)
    if (data.success) {
      yield put(slice.actions.setVipDetails(data?.data || {}))
    }
  } catch (e) {
    console.log(e)
  }
  yield put(appActions.setIsLoading(false))
}

export function* approveVip(action) {
  try {
    yield put(appActions.setIsLoading(true))
    const { id, startDate, endDate } = action.payload
    const { data } = yield call(axios.post, `${baseUrl}/vip/notable/${id}/approve/`)
    if (data.success) {
      let params = ""
      if (startDate) {
        params += `?start_date=${startDate}`
      }
      if (endDate) {
        params += `&end_date=${endDate}`
      }
      const refreshUrl = `${baseUrl}/vip/notable/${params}`
      const { data: newData } = yield call(axios.get, refreshUrl)
      if (newData.success) {
        yield put(
          slice.actions.setNotableVips({
            data: newData?.data?.notable_vips || [],
            count: newData?.data?.count || 0
          })
        )
      }
    }
  } catch (e) {
    console.log(e)
  }
  yield put(appActions.setIsLoading(false))
}

export function* secondApproveVip(action) {
  try {
    yield put(appActions.setIsLoading(true))
    const { id, is_second_approved, startDate, endDate } = action.payload
    const { data } = yield call(axios.post, `${baseUrl}/vip/notable/${id}/second-approve/`, {
      is_second_approved
    })
    if (data.success) {
      let params = ""
      if (startDate) {
        params += `?start_date=${startDate}`
      }
      if (endDate) {
        params += `&end_date=${endDate}`
      }
      const refreshUrl = `${baseUrl}/vip/notable/${params}`
      const { data: newData } = yield call(axios.get, refreshUrl)
      if (newData.success) {
        yield put(
          slice.actions.setNotableVips({
            data: newData?.data?.notable_vips || [],
            count: newData?.data?.count || 0
          })
        )
      }
    }
  } catch (e) {
    console.log(e)
  }
  yield put(appActions.setIsLoading(false))
}

export function* uploadVipImage(action) {
  try {
    const { data: formData, fieldName } = action.payload
    yield put(appActions.setIsLoading(true))
    const { data } = yield call(axios.post, `${baseUrl}/trivia/media/`, formData)
    if (data.success) {
      yield put(slice.actions.setVipImageId({ key: fieldName, id: data?.data?.id }))
    }
  } catch (e) {
    console.log(e)
  }
  yield put(appActions.setIsLoading(false))
}

export function* createNotableVip(action) {
  try {
    const { onSuccess, ...payload } = action.payload
    yield put(appActions.setIsLoading(true))
    const { data } = yield call(axios.post, `${baseUrl}/frontline/food-item/`, payload)
    if (data.success) {
      const { data: newData } = yield call(axios.get, `${baseUrl}/vip/notable/?all=True`)
      if (newData.success) {
        yield put(
          slice.actions.setNotableVips({
            data: newData?.data?.notable_vips || [],
            count: newData?.data?.count || 0
          })
        )
      }
      if (typeof onSuccess === "function") {
        onSuccess()
      }
    }
  } catch (e) {
    console.log(e)
  }
  yield put(appActions.setIsLoading(false))
}

export function* updateNotableVip(action) {
  try {
    const { onSuccess, ...payload } = action.payload
    yield put(appActions.setIsLoading(true))
    const { data } = yield call(
      axios.patch,
      `${baseUrl}/frontline/food-item/${payload.id}`,
      payload
    )
    if (data.success) {
      if (typeof onSuccess === "function") {
        onSuccess()
      }
      const { data: newData } = yield call(axios.get, `${baseUrl}/vip/notable/?all=True`)
      if (newData.success) {
        yield put(
          slice.actions.setNotableVips({
            data: newData?.data?.notable_vips || [],
            count: newData?.data?.count || 0
          })
        )
      }
    }
  } catch (e) {
    console.log(e)
  }
  yield put(appActions.setIsLoading(false))
}

export function* getNotableVipGroups() {
  try {
    yield put(appActions.setIsLoading(true))
    const { data } = yield call(axios.get, `${baseUrl}/highlights/`)
    if (data.success) {
      yield put(slice.actions.setNotableVipGroups(data?.data || []))
    }
  } catch (e) {
    console.log(e)
  }
  yield put(appActions.setIsLoading(false))
}

export function* createNotableVipGroup(action) {
  try {
    const { onSuccess, ...payload } = action.payload
    yield put(appActions.setIsLoading(true))
    const { data } = yield call(axios.post, `${baseUrl}/highlights/`, payload)
    if (data.success) {
      const { data: newData } = yield call(axios.get, `${baseUrl}/highlights/`)
      if (newData.success) {
        yield put(slice.actions.setNotableVipGroups(newData?.data || []))
      }
      if (typeof onSuccess === "function") {
        onSuccess()
      }
    }
  } catch (e) {
    console.log(e)
  }
  yield put(appActions.setIsLoading(false))
}

export function* updateNotableVipGroup(action) {
  try {
    const { id, onSuccess, ...payload } = action.payload
    yield put(appActions.setIsLoading(true))
    const { data } = yield call(axios.patch, `${baseUrl}/highlights/${id}/`, payload)
    if (data.success) {
      const { data: newData } = yield call(axios.get, `${baseUrl}/highlights/`)
      if (newData.success) {
        yield put(slice.actions.setNotableVipGroups(newData?.data || []))
      }
      if (typeof onSuccess === "function") {
        onSuccess()
      }
    }
  } catch (e) {
    console.log(e)
  }
  yield put(appActions.setIsLoading(false))
}

export function* deleteNotableVipGroup(action) {
  try {
    const { id } = action.payload
    yield put(appActions.setIsLoading(true))
    const { data } = yield call(axios.delete, `${baseUrl}/highlights/${id}/`)
    if (data.success) {
      const { data: newData } = yield call(axios.get, `${baseUrl}/highlights/`)
      if (newData.success) {
        yield put(slice.actions.setNotableVipGroups(newData?.data || []))
      }
    }
  } catch (e) {
    console.log(e)
  }
  yield put(appActions.setIsLoading(false))
}

export function* getVipGroupDynamicFields() {
  try {
    yield put(appActions.setIsLoading(true))
    const { data } = yield call(
      axios.get,
      `${baseUrl}/highlights/fields/?highlight_type=notable_groups`
    )
    if (data.success) {
      yield put(slice.actions.setMenuFields(data?.data || []))
    }
  } catch (e) {
    console.log(e)
  }
  yield put(appActions.setIsLoading(false))
}

export function* getNotableGroupTypes() {
  try {
    yield put(appActions.setIsLoading(true))
    const { data } = yield call(axios.get, `${baseUrl}/highlights/types/`)
    if (data.success) {
      const notableGroup = data.data.find((item) => item.name === "Notable Groups")
      if (notableGroup) {
        yield put(slice.actions.setNotableGroupTypeId(notableGroup.id))
      }
    }
  } catch (e) {
    console.log(e)
  }
  yield put(appActions.setIsLoading(false))
}

export function* createVipGroupSection(action) {
  try {
    const { payload, onClose } = action.payload
    yield put(appActions.setIsLoading(true))

    const { data } = yield call(axios.post, `${baseUrl}/highlights/fields/`, payload)
    if (data.success) {
      const { data: newData } = yield call(
        axios.get,
        `${baseUrl}/highlights/fields/?highlight_type=notable_groups`
      )
      if (newData.success) {
        yield put(slice.actions.setMenuFields(newData?.data || []))
      }
      onClose()
    }
  } catch (e) {
    console.log(e)
  }
  yield put(appActions.setIsLoading(false))
}

export function* updateVipGroupSection(action) {
  try {
    const { id, payload, onClose } = action.payload
    yield put(appActions.setIsLoading(true))
    const { data } = yield call(axios.patch, `${baseUrl}/highlights/fields/${id}/`, payload)
    if (data.success) {
      const { data: newData } = yield call(
        axios.get,
        `${baseUrl}/highlights/fields/?highlight_type=notable_groups`
      )
      if (newData.success) {
        yield put(slice.actions.setMenuFields(newData?.data || []))
      }
      onClose()
    }
  } catch (e) {
    console.log(e)
  }
  yield put(appActions.setIsLoading(false))
}

export function* deleteVipGroupSection(action) {
  try {
    const { id } = action.payload
    yield put(appActions.setIsLoading(true))
    const { data } = yield call(axios.delete, `${baseUrl}/highlights/fields/${id}`)
    if (data.success) {
      const { data: newData } = yield call(
        axios.get,
        `${baseUrl}/highlights/fields/?highlight_type=notable_groups`
      )
      if (newData.success) {
        yield put(slice.actions.setMenuFields(newData?.data || []))
      }
    }
  } catch (e) {
    console.log(e)
  }
  yield put(appActions.setIsLoading(false))
}

export function* createVipGroupField(action) {
  try {
    const { payload, onClose, parentId } = action.payload
    yield put(appActions.setIsLoading(true))
    const { data } = yield call(axios.post, `${baseUrl}/highlights/schema-fields/`, payload)
    if (data.success) {
      yield call(getVipGroupFields, { payload: parentId.id })
      const { data: newData } = yield call(
        axios.get,
        `${baseUrl}/highlights/fields/?highlight_type=notable_groups`
      )
      if (newData.success) {
        yield put(slice.actions.setMenuFields(newData?.data || []))
      }
      onClose()
    }
  } catch (e) {
    console.log(e)
  }
  yield put(appActions.setIsLoading(false))
}

export function* updateVipGroupField(action) {
  try {
    const { id, payload, onClose, parentId } = action.payload
    yield put(appActions.setIsLoading(true))
    const { data } = yield call(axios.patch, `${baseUrl}/highlights/schema-fields/${id}/`, payload)
    if (data.success) {
      yield call(getVipGroupFields, { payload: parentId.id })
      const { data: newData } = yield call(
        axios.get,
        `${baseUrl}/highlights/fields/?highlight_type=notable_groups`
      )
      if (newData.success) {
        yield put(slice.actions.setMenuFields(newData?.data || []))
      }
      onClose()
    }
  } catch (e) {
    console.log(e)
  }
  yield put(appActions.setIsLoading(false))
}

export function* deleteVipGroupField(action) {
  try {
    const { id, parentId } = action.payload
    yield put(appActions.setIsLoading(true))
    const { data } = yield call(axios.delete, `${baseUrl}/highlights/schema-fields/${id}/`)
    if (data.success) {
      yield call(getVipGroupFields, { payload: parentId.id })
      const { data: newData } = yield call(
        axios.get,
        `${baseUrl}/highlights/fields/?highlight_type=notable_groups`
      )
      if (newData.success) {
        yield put(slice.actions.setMenuFields(newData?.data || []))
      }
    }
  } catch (e) {
    console.log(e)
  }
  yield put(appActions.setIsLoading(false))
}

export function* getVipGroupFields(action) {
  try {
    yield put(appActions.setIsLoading(true))
    const { data } = yield call(
      axios.get,
      `${baseUrl}/highlights/schema-fields/?parent_field=${action.payload}`
    )
    if (data.success) {
      yield put(slice.actions.setSchemaFields(data.data))
    }
  } catch (e) {
    console.log(e)
  }
  yield put(appActions.setIsLoading(false))
}

export function* reorderVipGroupSections(action) {
  try {
    yield put(appActions.setIsLoading(true))
    const { data } = yield call(axios.post, `${baseUrl}/highlights/section/order/`, action.payload)
    if (data.success) {
      const { data: newData } = yield call(
        axios.get,
        `${baseUrl}/highlights/fields/?highlight_type=notable_groups`
      )
      if (newData.success) {
        yield put(slice.actions.setMenuFields(newData?.data || []))
      }
    }
  } catch (e) {
    console.log(e)
  }
  yield put(appActions.setIsLoading(false))
}

export function* getAvataarPrompt() {
  try {
    yield put(appActions.setIsLoading(true))
    const { data } = yield call(axios.get, `${baseUrl}/frontline/avatar/cms/prompt/`)
    if (data.success) {
      yield put(slice.actions.setAvataarPrompt(data?.data?.avatar_prompt || ""))
      yield put(slice.actions.setAvataarEnabled(data?.data?.avatar_enabled))
    }
  } catch (e) {
    console.log(e)
  }
  yield put(appActions.setIsLoading(false))
}

export function* updateAvataarPrompt(action) {
  try {
    yield put(appActions.setIsLoading(true))
    const { data } = yield call(
      axios.post,
      `${baseUrl}/frontline/avatar/cms/prompt/`,
      action.payload
    )
    if (data.success) {
      yield put(slice.actions.setAvataarPrompt(data?.data?.avatar_prompt || []))
      yield put(slice.actions.setAvataarEnabled(data?.data?.avatar_enabled))
    }
  } catch (e) {
    console.log(e)
  }
  yield put(appActions.setIsLoading(false))
}

export function* uploadRewardImage(action) {
  try {
    yield put(appActions.setIsLoading(true))
    const { data: formData } = action.payload

    const { data } = yield call(axios.post, `${baseUrl}/trivia/media/`, formData)
    if (data.success) {
      yield put(slice.actions.setUploadedImageId(data.data.id))
    }
  } catch (e) {
    console.error(e)
  }
  yield put(appActions.setIsLoading(false))
}

// ─── Tiers ───────────────────────────────────────────────────────────

export function* getTiers(action) {
  try {
    yield put(appActions.setIsLoading(true))
    const { restaurantId } = action.payload
    const { data } = yield call(axios.get, `${baseUrl}/rewards/admin/tiers/`, {
      params: { restaurant_id: restaurantId }
    })
    if (data.success) {
      yield put(
        slice.actions.setTiers({
          tiers: data?.data?.tiers,
          downgrade_enabled: data?.data?.downgrade_enabled
        })
      )
    }
  } catch (e) {
    console.error(e)
  } finally {
    yield put(appActions.setIsLoading(false))
  }
}

export function* createTier(action) {
  try {
    yield put(appActions.setIsLoading(true))
    const { payload, callback } = action.payload
    const { data } = yield call(axios.post, `${baseUrl}/rewards/admin/tiers/create/`, payload)
    if (data.success) {
      if (callback) callback()
      const { data: newData } = yield call(axios.get, `${baseUrl}/rewards/admin/tiers//`, {
        params: { restaurant_id: payload.restaurant_id }
      })
      if (newData.success) {
        yield put(
          slice.actions.setTiers({
            tiers: newData?.data?.tiers,
            downgrade_enabled: newData?.data?.downgrade_enabled
          })
        )
      }
    }
  } catch (e) {
    console.error(e)
  }
  yield put(appActions.setIsLoading(false))
}

export function* updateTier(action) {
  try {
    yield put(appActions.setIsLoading(true))
    const { tierId, payload, callback } = action.payload
    const { data } = yield call(
      axios.put,
      `${baseUrl}/rewards/admin/tiers/${tierId}/update/`,
      payload
    )
    if (data.success) {
      if (callback) callback()
      const { data: newData } = yield call(axios.get, `${baseUrl}/rewards/admin/tiers/`, {
        params: { restaurant_id: payload.restaurant_id }
      })
      if (newData.success) {
        yield put(
          slice.actions.setTiers({
            tiers: newData?.data?.tiers,
            downgrade_enabled: newData?.data?.downgrade_enabled
          })
        )
      }
    }
  } catch (e) {
    console.error(e)
  }
  yield put(appActions.setIsLoading(false))
}

export function* deleteTier(action) {
  try {
    yield put(appActions.setIsLoading(true))
    const { tierId, restaurantId, callback } = action.payload
    const { data } = yield call(axios.delete, `${baseUrl}/rewards/admin/tiers/${tierId}/delete/`)
    if (data.success) {
      if (callback) callback()
      const { data: newData } = yield call(axios.get, `${baseUrl}/rewards/admin/tiers/`, {
        params: { restaurant_id: restaurantId }
      })
      if (newData.success) {
        yield put(
          slice.actions.setTiers({
            tiers: newData?.data?.tiers,
            downgrade_enabled: newData?.data?.downgrade_enabled
          })
        )
      }
    }
  } catch (e) {
    console.error(e)
  }
  yield put(appActions.setIsLoading(false))
}

export function* updateTierOrder(action) {
  try {
    const { payload } = action.payload
    const { data } = yield call(axios.put, `${baseUrl}/rewards/admin/tiers/reorder/`, payload)
    if (data.success) {
      const { data: newData } = yield call(axios.get, `${baseUrl}/rewards/admin/tiers/`)
      if (newData.success) {
        yield put(
          slice.actions.setTiers({
            tiers: newData?.data?.tiers,
            downgrade_enabled: newData?.data?.downgrade_enabled
          })
        )
      }
    }
  } catch (e) {
    console.error(e)
  }
}

export function* getCategories() {
  try {
    yield put(appActions.setIsLoading(true))
    const { data } = yield call(axios.get, `${baseUrl}/rewards/admin/categories/`)
    if (data.success) {
      yield put(slice.actions.setCategories(data.data.results || data.data))
    }
  } catch (e) {
    console.error(e)
  }
  yield put(appActions.setIsLoading(false))
}

export function* createCategory(action) {
  try {
    yield put(appActions.setIsLoading(true))
    const { payload, callback } = action.payload
    const { data } = yield call(axios.post, `${baseUrl}/rewards/admin/categories/`, payload)
    if (data.success) {
      if (callback) callback()
      const { data: newData } = yield call(axios.get, `${baseUrl}/rewards/admin/categories/`)
      if (newData.success) {
        yield put(slice.actions.setCategories(newData.data.results || newData.data))
      }
    }
  } catch (e) {
    console.error(e)
  }
  yield put(appActions.setIsLoading(false))
}

export function* updateCategory(action) {
  try {
    yield put(appActions.setIsLoading(true))
    const { categoryId, payload, callback } = action.payload
    const { data } = yield call(
      axios.patch,
      `${baseUrl}/rewards/admin/categories/${categoryId}/`,
      payload
    )
    if (data.success) {
      if (callback) callback()
      const { data: newData } = yield call(axios.get, `${baseUrl}/rewards/admin/categories/`)
      if (newData.success) {
        yield put(slice.actions.setCategories(newData.data.results || newData.data))
      }
    }
  } catch (e) {
    console.error(e)
  }
  yield put(appActions.setIsLoading(false))
}

export function* deleteCategory(action) {
  try {
    yield put(appActions.setIsLoading(true))
    const { categoryId, callback } = action.payload
    const { data } = yield call(
      axios.delete,
      `${baseUrl}/rewards/admin/categories/${categoryId}/delete/`
    )
    if (data.success) {
      if (callback) callback()
      const { data: newData } = yield call(axios.get, `${baseUrl}/rewards/admin/categories/`)
      if (newData.success) {
        yield put(slice.actions.setCategories(newData.data.results || newData.data))
      }
    }
  } catch (e) {
    console.error(e)
  }
  yield put(appActions.setIsLoading(false))
}

export function* getCardTypes() {
  try {
    const { data } = yield call(axios.get, `${baseUrl}/rewards/admin/card-types/`)
    if (data.success) {
      yield put(slice.actions.setCardTypes(data.data.results || data.data))
    }
  } catch (e) {
    console.error(e)
  }
}

export function* getRewards(action) {
  try {
    yield put(appActions.setIsLoading(true))
    const { restaurantId, search } = action?.payload || {}
    const { data } = yield call(axios.get, `${baseUrl}/rewards/admin/gift-cards/`, {
      params: { restaurant_id: restaurantId, search: search || undefined }
    })
    if (data.success) {
      yield put(slice.actions.setRewards(data?.data?.tiers || []))
      yield put(slice.actions.setRewardsSpreeActive(Boolean(data?.data?.shopping_spree_active)))
    }
  } catch (e) {
    console.error(e)
  } finally {
    yield put(appActions.setIsLoading(false))
  }
}

export function* createReward(action) {
  try {
    yield put(appActions.setIsLoading(true))
    const { payload, callback } = action.payload
    const { data } = yield call(axios.post, `${baseUrl}/rewards/admin/gift-cards/create/`, payload)
    if (data.success) {
      toast.success("Reward created successfully", {
        position: "bottom-left",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: false,
        draggable: false,
        progress: undefined,
        theme: "dark"
      })
      if (callback) callback(data.data)
      const { data: newData } = yield call(axios.get, `${baseUrl}/rewards/admin/gift-cards/`, {})
      if (newData.success) {
        yield put(slice.actions.setRewards(newData?.data?.tiers || []))
      }
    }
  } catch (e) {
    console.error(e)
  } finally {
    yield put(appActions.setIsLoading(false))
  }
}

export function* updateReward(action) {
  try {
    yield put(appActions.setIsLoading(true))
    const { rewardId, payload, callback } = action.payload
    const { data } = yield call(
      axios.put,
      `${baseUrl}/rewards/admin/gift-cards/${rewardId}/update/`,
      payload
    )
    if (data.success) {
      toast.success("Reward updated successfully", {
        position: "bottom-left",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: false,
        draggable: false,
        progress: undefined,
        theme: "dark"
      })
      if (callback) callback(data.data)
      const { data: newData } = yield call(axios.get, `${baseUrl}/rewards/admin/gift-cards/`, {})
      if (newData.success) {
        yield put(slice.actions.setRewards(newData?.data?.tiers || []))
      }
    }
  } catch (e) {
    console.error(e)
  } finally {
    yield put(appActions.setIsLoading(false))
  }
}

export function* deleteReward(action) {
  try {
    yield put(appActions.setIsLoading(true))
    const { rewardId, callback } = action.payload
    const { data } = yield call(
      axios.delete,
      `${baseUrl}/rewards/admin/gift-cards/${rewardId}/delete/`
    )
    if (data.success) {
      if (callback) callback()
      const { data: newData } = yield call(axios.get, `${baseUrl}/rewards/admin/gift-cards/`, {})
      if (newData.success) {
        yield put(slice.actions.setRewards(newData?.data?.tiers || []))
      }
    }
  } catch (e) {
    console.error(e)
  } finally {
    yield put(appActions.setIsLoading(false))
  }
}

export function* reorderRewards(action) {
  try {
    yield put(appActions.setIsLoading(true))
    const { payload } = action.payload
    const { data } = yield call(axios.post, `${baseUrl}/rewards/admin/gift-cards/reorder/`, payload)
    if (data.success) {
      yield call(getRewards)
    }
  } catch (e) {
    console.error(e)
  } finally {
    yield put(appActions.setIsLoading(false))
  }
}

export function* getSpreeWindowQuantities(action) {
  try {
    yield put(appActions.setIsLoading(true))
    const { windowId } = action.payload
    const { data } = yield call(
      axios.get,
      `${baseUrl}/rewards/admin/shopping-spree-windows/${windowId}/quantities/`
    )
    if (data.success) {
      yield put(slice.actions.setSpreeWindowData(data?.data || null))
    }
  } catch (e) {
    console.error(e)
  } finally {
    yield put(appActions.setIsLoading(false))
  }
}

export function* setRewardSpreeQuantity(action) {
  try {
    yield put(appActions.setIsLoading(true))
    const { rewardId, totalQuantity, restaurantId, search, callback } = action.payload
    yield call(axios.post, `${baseUrl}/rewards/admin/gift-cards/${rewardId}/spree-quantity/`, {
      total_quantity: totalQuantity
    })
    toast.success("Spree quantity updated successfully", {
      position: "bottom-left",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: false,
      draggable: false,
      progress: undefined,
      theme: "dark"
    })
    if (callback) callback()
    const { data: newData } = yield call(axios.get, `${baseUrl}/rewards/admin/gift-cards/`, {
      params: { restaurant_id: restaurantId, search: search || undefined }
    })
    if (newData.success) {
      yield put(slice.actions.setRewards(newData?.data?.tiers || []))
      yield put(slice.actions.setRewardsSpreeActive(Boolean(newData?.data?.shopping_spree_active)))
    }
  } catch (e) {
    console.error(e)
  } finally {
    yield put(appActions.setIsLoading(false))
  }
}

export function* uploadGiftCardCoupons(action) {
  try {
    const { rewardId, codes, callback } = action.payload
    const { data } = yield call(
      axios.post,
      `${baseUrl}/rewards/admin/gift-cards/${rewardId}/coupon-codes/`,
      { codes }
    )
    if (data.success) {
      toast.success("Coupons uploaded successfully", {
        position: "bottom-left",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: false,
        draggable: false,
        progress: undefined,
        theme: "dark"
      })
      if (callback) callback()
      const { data: newData } = yield call(axios.get, `${baseUrl}/rewards/admin/gift-cards/`, {})
      if (newData.success) {
        yield put(slice.actions.setRewards(newData?.data?.tiers || []))
      }
    }
  } catch (e) {
    console.error(e)
  }
}

export function* getGiftCardRedemptions(action) {
  try {
    yield put(appActions.setIsLoading(true))
    const { giftCardId, params, restaurantId } = action.payload
    const { data } = yield call(axios.get, `${baseUrl}/rewards/admin/redemptions/`, {
      params: { ...params, gift_card_id: giftCardId, restaurant_id: restaurantId }
    })
    if (data.success) {
      yield put(slice.actions.setGiftCardRedemptions(data.data))
    }
  } catch (e) {
    console.error(e)
  } finally {
    yield put(appActions.setIsLoading(false))
  }
}

export function* getAllRedemptions(action) {
  try {
    yield put(appActions.setIsLoading(true))
    const { restaurantId } = action.payload
    const { data } = yield call(
      axios.get,
      `${baseUrl}/rewards/admin/redemptions/?restaurant_id=${restaurantId}`
    )
    if (data.success) {
      yield put(slice.actions.setRedemptions(data?.data))
    }
  } catch (e) {
    console.error(e)
  } finally {
    yield put(appActions.setIsLoading(false))
  }
}

export function* changeRedemptionStatus(action) {
  try {
    yield put(appActions.setIsLoading(true))
    const { redemptionId, status, callback } = action.payload
    const { data } = yield call(
      axios.patch,
      `${baseUrl}/rewards/admin/redemptions/${redemptionId}/change-status/`,
      { status }
    )
    if (data.success) {
      if (callback) callback()
      const { data: newData } = yield call(axios.get, `${baseUrl}/rewards/admin/redemptions/`)
      if (newData.success) {
        yield put(slice.actions.setRedemptions(newData?.data))
      }
    }
  } catch (e) {
    console.error(e)
  } finally {
    yield put(appActions.setIsLoading(false))
  }
}

export function* getRewardState(action) {
  try {
    const { restaurantId } = action.payload
    const { data } = yield call(axios.get, `${baseUrl}/rewards/admin/rewards-config/`, {
      params: { restaurant_id: restaurantId }
    })
    if (data.success) {
      yield put(slice.actions.setRewardState(data?.data?.data))
    }
  } catch (e) {
    console.error(e)
  }
}

export function* updateRewardState(action) {
  try {
    yield put(appActions.setIsLoading(true))
    const { payload, callback } = action.payload
    const { data } = yield call(axios.put, `${baseUrl}/rewards/admin/rewards-config/`, payload)
    if (data?.success) {
      const { data: newData } = yield call(axios.get, `${baseUrl}/rewards/admin/tiers/`, {
        params: { restaurant_id: payload.restaurant_id }
      })
      yield put(
        slice.actions.setTiers({
          tiers: newData?.data?.tiers,
          downgrade_enabled: newData?.data?.downgrade_enabled
        })
      )
      if (callback) callback()
    }
  } catch (e) {
    console.error(e)
  } finally {
    yield put(appActions.setIsLoading(false))
  }
}

export function* getAnalyticsSummary(action) {
  try {
    yield put(appActions.setIsLoading(true))
    const { restaurantId, startDate, endDate } = action.payload
    const { data } = yield call(axios.get, `${baseUrl}/rewards/admin/analytics/overview/`, {
      params: { restaurant_id: restaurantId, start_date: startDate, end_date: endDate }
    })
    if (data?.success) {
      yield put(slice.actions.setAnalytics(data.data))
    }
  } catch (e) {
    console.error(e)
  } finally {
    yield put(appActions.setIsLoading(false))
  }
}

export function* exportAnalytics(action) {
  try {
    yield put(appActions.setIsLoading(true))
    const { restaurantId, startDate, endDate } = action.payload
    const { data } = yield call(axios.get, `${baseUrl}/rewards/admin/analytics/export/`, {
      params: { restaurant_id: restaurantId, start_date: startDate, end_date: endDate },
      responseType: "blob"
    })
    saveAs(data, `rewards-analytics-${startDate}-to-${endDate}.csv`)
  } catch (e) {
    console.error(e)
  } finally {
    yield put(appActions.setIsLoading(false))
  }
}

export function* getSectionTypes() {
  try {
    yield put(appActions.setIsLoading(true))
    const { data } = yield call(axios.get, `${baseUrl}/pre-shift/section-types/`)
    if (data?.success) {
      yield put(slice.actions.setSectionTypes(data?.data))
    }
  } catch (e) {
    console.error(e)
  } finally {
    yield put(appActions.setIsLoading(false))
  }
}

export function* createSectionType(action) {
  try {
    yield put(appActions.setIsLoading(true))
    const { payload, callback } = action.payload
    const { data } = yield call(axios.post, `${baseUrl}/pre-shift/section-types/`, payload)
    if (data?.success) {
      if (callback) callback(data?.data)
      const { data: newData } = yield call(axios.get, `${baseUrl}/pre-shift/section-types/`)
      if (newData?.success) {
        yield put(slice.actions.setSectionTypes(newData?.data))
      }
    }
  } catch (e) {
    console.error(e)
  } finally {
    yield put(appActions.setIsLoading(false))
  }
}

export function* getSectionTypeDetail(action) {
  try {
    yield put(appActions.setIsLoading(true))
    const { id } = action.payload
    const { data } = yield call(axios.get, `${baseUrl}/pre-shift/section-types/${id}/`)
    if (data?.success) {
      yield put(slice.actions.setSelectedSectionType(data?.data))
    }
  } catch (e) {
    console.error(e)
  } finally {
    yield put(appActions.setIsLoading(false))
  }
}

export function* updateSectionType(action) {
  try {
    yield put(appActions.setIsLoading(true))
    const { id, payload, callback } = action.payload
    const { data } = yield call(axios.patch, `${baseUrl}/pre-shift/section-types/${id}/`, payload)
    if (data?.success) {
      if (callback) callback(data?.data)
      const { data: newData } = yield call(axios.get, `${baseUrl}/pre-shift/section-types/`)
      if (newData?.success) {
        yield put(slice.actions.setSectionTypes(newData?.data))
      }
    }
  } catch (e) {
    console.error(e)
  } finally {
    yield put(appActions.setIsLoading(false))
  }
}

export function* deleteSectionType(action) {
  try {
    yield put(appActions.setIsLoading(true))
    const { id, callback } = action.payload
    yield call(axios.delete, `${baseUrl}/pre-shift/section-types/${id}/`)
    yield call(getSectionTypes)
    if (callback) callback()
  } catch (e) {
    console.error(e)
  } finally {
    yield put(appActions.setIsLoading(false))
  }
}

export function* createSectionField(action) {
  try {
    yield put(appActions.setIsLoading(true))
    const { payload, callback } = action.payload
    const { data } = yield call(axios.post, `${baseUrl}/pre-shift/section-fields/`, payload)
    if (data?.success) {
      if (callback) callback(data)
      const { data: newData } = yield call(
        axios.get,
        `${baseUrl}/pre-shift/section-types/${payload.section_type}/`
      )
      if (newData?.success) {
        yield put(slice.actions.setSelectedSectionType(newData?.data))
      }
    }
  } catch (e) {
    console.error(e)
  } finally {
    yield put(appActions.setIsLoading(false))
  }
}

export function* updateSectionField(action) {
  try {
    yield put(appActions.setIsLoading(true))
    const { id, payload, callback } = action.payload
    const { data } = yield call(axios.patch, `${baseUrl}/pre-shift/section-fields/${id}/`, payload)
    if (data?.success) {
      if (callback) callback(data)
      const { data: newData } = yield call(
        axios.get,
        `${baseUrl}/pre-shift/section-types/${payload.section_type}/`
      )
      if (newData?.success) {
        yield put(slice.actions.setSelectedSectionType(newData?.data))
      }
    }
  } catch (e) {
    console.error(e)
  } finally {
    yield put(appActions.setIsLoading(false))
  }
}

export function* deleteSectionField(action) {
  try {
    yield put(appActions.setIsLoading(true))
    const { id, section_type_id, callback } = action.payload
    const { data } = yield call(axios.delete, `${baseUrl}/pre-shift/section-fields/${id}/`)
    if (data?.success) {
      if (section_type_id) {
        const { data: newData } = yield call(
          axios.get,
          `${baseUrl}/pre-shift/section-types/${section_type_id}/`
        )
        if (newData?.success) {
          yield put(slice.actions.setSelectedSectionType(newData?.data))
        }
      }
      if (callback) callback()
    }
  } catch (e) {
    console.error(e)
  } finally {
    yield put(appActions.setIsLoading(false))
  }
}

export function* reorderSectionTypes(action) {
  try {
    yield put(appActions.setIsLoading(true))
    const { payload, callback } = action.payload
    const { data } = yield call(axios.post, `${baseUrl}/pre-shift/section-types/reorder/`, payload)
    if (data?.success) {
      const { data: newData } = yield call(axios.get, `${baseUrl}/pre-shift/section-types/`)
      if (newData?.success) {
        yield put(slice.actions.setSectionTypes(newData?.data))
      }
      if (callback) callback()
    }
  } catch (e) {
    console.error(e)
  } finally {
    yield put(appActions.setIsLoading(false))
  }
}

export function* reorderSectionFields(action) {
  try {
    yield put(appActions.setIsLoading(true))
    const { section_type_id, payload, callback } = action.payload
    const { data } = yield call(axios.post, `${baseUrl}/pre-shift/section-fields/reorder/`, payload)
    if (data?.success) {
      const { data: newData } = yield call(
        axios.get,
        `${baseUrl}/pre-shift/section-types/${section_type_id}/`
      )
      if (newData?.success) {
        yield put(slice.actions.setSelectedSectionType(newData?.data))
      }
      if (callback) callback()
    }
  } catch (e) {
    console.error(e)
  } finally {
    yield put(appActions.setIsLoading(false))
  }
}

export function* getPreshifts(action) {
  try {
    yield put(appActions.setIsLoading(true))
    const { status, date } = action.payload || {}
    let queryParams = {}
    if (status) queryParams.status = status
    if (date) queryParams.date = date

    const { data } = yield call(axios.get, `${baseUrl}/pre-shift/`, { params: queryParams })
    if (data?.success) {
      yield put(slice.actions.setPreshiftList(data?.data || []))
    }
  } catch (e) {
    console.error(e)
  } finally {
    yield put(appActions.setIsLoading(false))
  }
}

export function* createPreshift(action) {
  try {
    yield put(appActions.setIsLoading(true))
    const { payload, callback } = action.payload
    const { data } = yield call(axios.post, `${baseUrl}/pre-shift/`, payload)
    if (data?.success) {
      toast.success("Pre-shift created successfully", {
        position: "bottom-left",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: false,
        draggable: false,
        progress: undefined,
        theme: "dark"
      })
      yield call(getPreshifts)
      if (callback) callback(data)
    }
  } catch (e) {
    console.error(e)
  } finally {
    yield put(appActions.setIsLoading(false))
  }
}

export function* getPreshiftDetail(action) {
  try {
    yield put(appActions.setIsLoading(true))
    const { id } = action.payload
    const { data } = yield call(axios.get, `${baseUrl}/pre-shift/${id}`)
    if (data?.success) {
      yield put(slice.actions.setSelectedPreshiftDetail(data?.data))
    }
  } catch (e) {
    console.error(e)
  } finally {
    yield put(appActions.setIsLoading(false))
  }
}

export function* updatePreshift(action) {
  try {
    yield put(appActions.setIsLoading(true))
    const { id, payload, callback } = action.payload
    const { data } = yield call(axios.patch, `${baseUrl}/pre-shift/${id}/`, payload)
    if (data?.success) {
      yield put(slice.actions.setSelectedPreshiftDetail(data?.data))
      if (callback) callback(data)
    }
  } catch (e) {
    console.error(e)
  } finally {
    yield put(appActions.setIsLoading(false))
  }
}

export function* deletePreshift(action) {
  try {
    yield put(appActions.setIsLoading(true))
    const { id, callback } = action.payload
    yield call(axios.delete, `${baseUrl}/pre-shift/${id}/`)
    if (callback) callback()
    const { data } = yield call(axios.get, `${baseUrl}/pre-shift/`)
    if (data?.success) {
      yield put(slice.actions.setPreshiftList(data?.data?.data || data?.data || []))
    }
  } catch (e) {
    console.error(e)
  } finally {
    yield put(appActions.setIsLoading(false))
  }
}

export function* publishPreshift(action) {
  try {
    yield put(appActions.setIsLoading(true))
    const { id, callback } = action.payload
    const { data } = yield call(axios.post, `${baseUrl}/pre-shift/${id}/publish/`)
    if (data?.success) {
      toast.success("Pre-shift published successfully", {
        position: "bottom-left",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: false,
        draggable: false,
        progress: undefined,
        theme: "dark"
      })
      yield put(slice.actions.setSelectedPreshiftDetail(data?.data))
      if (callback) callback()
    }
  } catch (e) {
    console.error(e)
  } finally {
    yield put(appActions.setIsLoading(false))
  }
}

export function* unpublishPreshift(action) {
  try {
    yield put(appActions.setIsLoading(true))
    const { id, callback } = action.payload
    const { data } = yield call(axios.post, `${baseUrl}/pre-shift/${id}/unpublish/`)
    if (data?.success) {
      toast.success("Pre-shift unpublished successfully", {
        position: "bottom-left",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: false,
        draggable: false,
        progress: undefined,
        theme: "dark"
      })
      yield put(slice.actions.setSelectedPreshiftDetail(data?.data))
      if (callback) callback(data)
    }
  } catch (e) {
    console.error(e)
  } finally {
    yield put(appActions.setIsLoading(false))
  }
}

export function* updatePreshiftSectionData(action) {
  try {
    const { preshift_id, section_id, payload, callback } = action.payload
    const { data } = yield call(
      axios.patch,
      `${baseUrl}/pre-shift/${preshift_id}/sections/${section_id}/`,
      payload
    )
    if (data?.success) {
      if (callback) callback(data)
    }
  } catch (e) {
    console.error(e)
  }
}

export function* updateAllPreshiftSections(action) {
  try {
    yield put(appActions.setIsLoading(true))
    const { preshift_id, sections, callback } = action.payload
    for (const section of sections) {
      yield call(axios.patch, `${baseUrl}/pre-shift/${preshift_id}/sections/${section.id}/`, {
        dynamic_field_data: section.dynamic_field_data
      })
    }
    yield call(getPreshiftDetail, { payload: { id: preshift_id } })
    if (callback) callback()
  } catch (e) {
    console.error(e)
  } finally {
    yield put(appActions.setIsLoading(false))
  }
}

export function* addItemsToSection(action) {
  try {
    const { preshift_id, section_id, payload, callback } = action.payload
    const { data } = yield call(
      axios.post,
      `${baseUrl}/pre-shift/${preshift_id}/sections/${section_id}/items/`,
      payload
    )

    if (data?.success) {
      if (callback) callback(data)
      const { data: newData } = yield call(axios.get, `${baseUrl}/pre-shift/${preshift_id}/`)
      if (newData?.success) {
        yield put(slice.actions.setSelectedPreshiftDetail(newData?.data))
      }
    }
  } catch (e) {
    console.error(e)
  }
}

export function* removeItemFromSection(action) {
  try {
    const { preshift_id, section_id, item_id } = action.payload
    yield call(
      axios.delete,
      `${baseUrl}/pre-shift/${preshift_id}/sections/${section_id}/items/${item_id}/`
    )
    const { data: newData } = yield call(axios.get, `${baseUrl}/pre-shift/${preshift_id}/`)
    if (newData?.success) {
      yield put(slice.actions.setSelectedPreshiftDetail(newData?.data))
    }
  } catch (e) {
    console.error(e)
  }
}

export function* uploadPreshiftMedia(action) {
  try {
    yield put(appActions.setIsLoading(true))
    const { payload, callback } = action.payload
    const { data } = yield call(axios.post, `${baseUrl}/trivia/media/`, payload)
    if (data?.success) {
      if (callback) callback(data)
    }
  } catch (e) {
    console.error(e)
  } finally {
    yield put(appActions.setIsLoading(false))
  }
}

export function* getVipCategories() {
  try {
    yield put(appActions.setIsLoading(true))
    const menuSubCategory = yield select((store) => store?.marketing?.menu?.menuSubCategory)
    const { data } = yield call(
      axios.get,
      `${baseUrl}/frontline/web-menu-list/?meal-period=vip&&food-type=${menuSubCategory?.[0]?.name}`
    )
    if (data?.success) {
      const items = data?.data || []
      const seen = new Set()
      const uniqueCategories = items.reduce((acc, item) => {
        if (item.food_category_id && !seen.has(item.food_category_id)) {
          seen.add(item.food_category_id)
          acc.push({ label: item.food_category, value: item.food_category_id })
        }
        return acc
      }, [])
      yield put(slice.actions.setVipCategories(uniqueCategories))
    }
  } catch (e) {
    console.error(e)
  } finally {
    yield put(appActions.setIsLoading(false))
  }
}

export function* reorderPreshiftSections(action) {
  try {
    yield put(appActions.setIsLoading(true))
    const { id, payload, callback } = action.payload
    const { data } = yield call(axios.post, `${baseUrl}/pre-shift/${id}/sections/reorder/`, payload)
    if (data?.success) {
      if (callback) callback()
      yield call(getPreshiftDetail, { payload: { id } })
    }
  } catch (e) {
    console.error(e)
  } finally {
    yield put(appActions.setIsLoading(false))
  }
}

export function* copyPreshift(action) {
  try {
    yield put(appActions.setIsLoading(true))
    const { payload, callback } = action.payload
    const { data } = yield call(axios.post, `${baseUrl}/pre-shift/copy/`, payload)
    if (data?.success) {
      toast.success("Pre-shift copied successfully", {
        position: "bottom-left",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: false,
        draggable: false,
        progress: undefined,
        theme: "dark"
      })
      yield call(getPreshifts, { payload: {} })
      if (callback) callback(data)
    }
  } catch (e) {
    console.error(e)
  } finally {
    yield put(appActions.setIsLoading(false))
  }
}

// ─── Restaurant Management (CMS) Sagas ───────────────────────────────────────

export function* getCMSRestaurantList(action) {
  try {
    yield put(appActions.setIsLoading(true))
    const { search = "", owner = "", lite = "" } = action.payload || {}
    let params = `?`
    if (search) params += `search=${search}`
    if (owner) params += `&owner=${owner}`
    if (lite !== "") params += `&lite=${lite}`
    const { data } = yield call(axios.get, `${baseUrl}/user/cms/restaurants/${params}`)
    if (data?.success) {
      yield put(slice.actions.setCMSRestaurantList(data?.data || []))
    }
  } catch (e) {
    console.error(e)
  } finally {
    yield put(appActions.setIsLoading(false))
  }
}

export function* getCMSRestaurantDetail(action) {
  try {
    yield put(appActions.setIsLoading(true))
    const { id } = action.payload
    const { data } = yield call(axios.get, `${baseUrl}/user/cms/restaurants/${id}/`)
    if (data?.success) {
      yield put(slice.actions.setCMSRestaurantDetail(data?.data))
    }
  } catch (e) {
    console.error(e)
  } finally {
    yield put(appActions.setIsLoading(false))
  }
}

export function* createCMSRestaurant(action) {
  try {
    yield put(appActions.setIsLoading(true))
    const { payload, onSuccess } = action.payload
    const { data } = yield call(axios.post, `${baseUrl}/user/cms/restaurants/`, payload)
    if (data?.success) {
      toast.success("Restaurant created successfully", { position: "bottom-left", theme: "dark" })
      if (onSuccess) onSuccess(data.data)
    }
  } catch (e) {
    console.log(e)
  } finally {
    yield put(appActions.setIsLoading(false))
  }
}

export function* updateCMSRestaurant(action) {
  try {
    yield put(appActions.setIsLoading(true))
    const { id, payload, onSuccess } = action.payload
    const { data } = yield call(axios.patch, `${baseUrl}/user/cms/restaurants/${id}/`, payload)
    if (data?.success) {
      toast.success("Restaurant updated successfully", { position: "bottom-left", theme: "dark" })
      if (onSuccess) onSuccess(data.data)
    }
  } catch (e) {
    console.log(e)
  } finally {
    yield put(appActions.setIsLoading(false))
  }
}

export function* reorderCMSRestaurants(action) {
  try {
    yield put(appActions.setIsLoading(true))
    const { payload, onSuccess } = action.payload
    const { data } = yield call(axios.post, `${baseUrl}/user/cms/restaurants/reorder/`, payload)
    if (data?.success) {
      if (onSuccess) onSuccess()
    }
  } catch (e) {
    console.error(e)
  } finally {
    yield put(appActions.setIsLoading(false))
  }
}

export function* getCMSRestaurantGroupList(action) {
  try {
    yield put(appActions.setIsLoading(true))
    const { search = "" } = action.payload || {}
    let params = ""
    if (search) params = `?search=${search}`
    const { data } = yield call(axios.get, `${baseUrl}/user/cms/restaurant-groups/${params}`)
    if (data?.success) {
      yield put(slice.actions.setCMSRestaurantGroupList(data?.data || []))
    }
  } catch (e) {
    console.error(e)
  } finally {
    yield put(appActions.setIsLoading(false))
  }
}

export function* getCMSRestaurantGroupDetail(action) {
  try {
    yield put(appActions.setIsLoading(true))
    const { id } = action.payload
    const { data } = yield call(axios.get, `${baseUrl}/user/cms/restaurant-groups/${id}/`)
    if (data?.success) {
      yield put(slice.actions.setCMSRestaurantGroupDetail(data.data))
    }
  } catch (e) {
    console.error(e)
  } finally {
    yield put(appActions.setIsLoading(false))
  }
}

export function* createCMSRestaurantGroup(action) {
  try {
    yield put(appActions.setIsLoading(true))
    const { payload, onSuccess } = action.payload
    const { data } = yield call(axios.post, `${baseUrl}/user/cms/restaurant-groups/`, payload)
    if (data?.success) {
      toast.success("Restaurant group created successfully", {
        position: "bottom-left",
        theme: "dark"
      })
      if (onSuccess) onSuccess(data.data)
    }
  } catch (e) {
    console.log(e)
  } finally {
    yield put(appActions.setIsLoading(false))
  }
}

export function* updateCMSRestaurantGroup(action) {
  try {
    yield put(appActions.setIsLoading(true))
    const { id, payload, onSuccess } = action.payload
    const { data } = yield call(
      axios.patch,
      `${baseUrl}/user/cms/restaurant-groups/${id}/`,
      payload
    )
    if (data?.success) {
      if (onSuccess) onSuccess(data.data)
    }
  } catch (e) {
    console.log(e)
  } finally {
    yield put(appActions.setIsLoading(false))
  }
}

export function* getCMSUsersForAssignment(action) {
  try {
    const { search = "", restaurant_id = "" } = action.payload || {}
    let params = ""
    const parts = []
    if (search) parts.push(`search=${search}`)
    if (restaurant_id) parts.push(`restaurant_id=${restaurant_id}`)
    if (parts.length) params = `?${parts.join("&")}`
    const { data } = yield call(axios.get, `${baseUrl}/user/cms/users/${params}`)
    if (data?.success) {
      yield put(slice.actions.setCMSUsersForAssignment(data.data?.results || data.data || []))
    }
  } catch (e) {
    console.error(e)
  }
}

export function* uploadCMSMedia(action) {
  try {
    const { payload, onSuccess } = action.payload
    const { data } = yield call(axios.post, `${baseUrl}/trivia/media/`, payload)
    if (data?.success && onSuccess) {
      onSuccess(data.data)
    }
  } catch (e) {
    console.log(e)
  }
}

export function* getRaffleWinners(action) {
  try {
    yield put(appActions.setIsLoading(true))
    const { restaurantId } = action.payload || {}
    const params = restaurantId ? `?restaurant_id=${restaurantId}` : ""
    const { data } = yield call(
      axios.get,
      `${baseUrl}/frontline/raffle-winner/admin/list/${params}`
    )
    if (data?.success) {
      yield put(slice.actions.setRaffleWinners(data?.data || []))
    }
  } catch (e) {
    console.error(e)
  } finally {
    yield put(appActions.setIsLoading(false))
  }
}

export function* updateRaffleWinnerPrizeClaimed(action) {
  try {
    yield put(appActions.setIsLoading(true))
    const { id, prize_claimed, onSuccess } = action.payload
    const { data } = yield call(
      axios.patch,
      `${baseUrl}/frontline/raffle-winner/${id}/prize-claimed/`,
      { prize_claimed }
    )
    if (data?.success) {
      if (onSuccess) onSuccess()
      yield put(
        slice.actions.setRaffleWinners(
          (yield select((state) => state.superAdmin.raffleWinners)).map((w) =>
            w.id === id ? { ...w, prize_claimed } : w
          )
        )
      )
    }
  } catch (e) {
    console.log(e)
  } finally {
    yield put(appActions.setIsLoading(false))
  }
}

export function* getShoppingSpreeWindows() {
  try {
    yield put(appActions.setIsLoading(true))
    const { data } = yield call(axios.get, `${baseUrl}/rewards/admin/shopping-spree-windows/`)
    if (data?.success) {
      yield put(slice.actions.setShoppingSpreeWindows(data?.data?.data || []))
    }
  } catch (e) {
    console.error(e)
  } finally {
    yield put(appActions.setIsLoading(false))
  }
}

export function* createShoppingSpreeWindow(action) {
  try {
    yield put(appActions.setIsLoading(true))
    const { payload, callback } = action.payload
    const { data } = yield call(
      axios.post,
      `${baseUrl}/rewards/admin/shopping-spree-windows/`,
      payload
    )
    if (data?.success) {
      const { data: listData } = yield call(
        axios.get,
        `${baseUrl}/rewards/admin/shopping-spree-windows/`
      )
      if (listData?.success) {
        yield put(slice.actions.setShoppingSpreeWindows(listData?.data?.data || []))
      }
      if (callback) callback()
    }
  } catch (e) {
    console.error(e)
  } finally {
    yield put(appActions.setIsLoading(false))
  }
}

export function* updateShoppingSpreeWindow(action) {
  try {
    yield put(appActions.setIsLoading(true))
    const { windowId, payload, callback } = action.payload
    const { data } = yield call(
      axios.patch,
      `${baseUrl}/rewards/admin/shopping-spree-windows/${windowId}/`,
      payload
    )
    if (data?.success) {
      const { data: listData } = yield call(
        axios.get,
        `${baseUrl}/rewards/admin/shopping-spree-windows/`
      )
      if (listData?.success) {
        yield put(slice.actions.setShoppingSpreeWindows(listData?.data?.data || []))
      }
      if (callback) callback()
    }
  } catch (e) {
    console.error(e)
  } finally {
    yield put(appActions.setIsLoading(false))
  }
}

export function* deleteShoppingSpreeWindow(action) {
  try {
    yield put(appActions.setIsLoading(true))
    const { windowId, callback } = action.payload
    const { data } = yield call(
      axios.delete,
      `${baseUrl}/rewards/admin/shopping-spree-windows/${windowId}/`
    )
    if (data?.success) {
      const { data: listData } = yield call(
        axios.get,
        `${baseUrl}/rewards/admin/shopping-spree-windows/`
      )
      if (listData?.success) {
        yield put(slice.actions.setShoppingSpreeWindows(listData?.data?.data || []))
      }
      if (callback) callback()
    }
  } catch (e) {
    console.error(e)
  } finally {
    yield put(appActions.setIsLoading(false))
  }
}
